<template>
  <div class="content background1" style="display: flex">
    <div class="tableBox9" v-if="!qrCodeShow">
      <div class="tableMes">
        <div class="table">
          <el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
            <el-tab-pane :label="$t('label_429')" name="first">
              <template v-if="treeShow">
                <tree ref="tree0" :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
              </template>
            </el-tab-pane>
            <el-tab-pane :label="$t('label_161')" name="second">
              <template v-if="treeShow">
                <tree ref="tree1" :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="right-showbtn" @click="showBtn">
      <div class="right-showbtn-qrcode-background">
        <i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
        <i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
      </div>
    </div>
    <div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
      <div class="tableMes">
        <div class="table" style="padding: 0;">
          <div class="treeMes" v-if="getTreeMes=='1'">
            <p class="title"><span class="spot">{{'<' + deviceName + '>'}}</span>{{$t('label_287')}}</p>
            <div class="chooseBox" style="height: 100px;">
              <div class="selectBox">
                <div>
                  <div class="selectChoose">
                    <div class="selectText" style="width: 155px;">
                      <p>{{$t('label_593')}}</p>
                    </div>
                    <div class="select" style="width:350px">
                      <el-input v-model="selectDataList.name" clearable></el-input>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose" style="width: 600px;">
                    <div class="selectText" style="width: 155px">
                      <p>{{$t('label_290')}}</p>
                    </div>
                    <div class="select" style="width:350px;margin-top: 8px;">
                      <el-checkbox-group v-model="selectDataList.urgentLevel1" @change="levelSelect">
                        <el-checkbox v-for="item in levelList" :label="item.key" :key="item.key">{{item.val}}
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </div>
                </div>
              </div>
              <div class="selectBox">
                <div>
                  <div class="selectChoose">
                    <div class="selectText" style="width: 155px;">
                      <p>{{$t('label_293')}}</p>
                    </div>
                    <div class="select" style="width:350px">
                      <el-input v-model="selectDataList.reportPerson" clearable></el-input>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="selectChoose1" style="width: 600px;">
                    <div class="selectText" style="width: 155px">
                      <p>{{$t('label_296')}}</p>
                    </div>
                    <div class="select" style="width:350px">
                      <el-date-picker v-model="Readytime" type="daterange" format="yyyy-MM-dd" value-format='yyyy-MM-dd'
                                      :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')">
                      </el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttonBox buttonBoxRight" style="margin: 5px 0; float: left;top: 120px;">
                <div>
                  <div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
                </div>
              </div>
            </div>
            <div class="spotStatusNumList spotStatusNumListSmall">
              <!-- <div class="statusMesBox" v-for="(item,index) in spotStatusNumList" :class="item.check==true?'check':''"> -->
              <div class="statusMesBox">
                <div class="textBox">
                  <p style="height: 48px;">{{$t('label_272')}}</p>
                  <p class="num" style="color:#000000">{{spotStatusNumList[0].num}}</p>
                </div>
              </div>
              <div class="statusMesBox" :class="spotStatusNumList[1].check==true?'check':''">
                <div class="textBox">
                  <p style="height: 48px;">{{$t('label_299')}}</p>
                  <p class="num" style="color:#e60000">{{spotStatusNumList[1].num}}</p>
                </div>
                <div class="checkBox">
                  <el-checkbox label="" v-model="spotStatusNumList[1].check"></el-checkbox>
                </div>
              </div>
              <div class="statusMesBox" :class="spotStatusNumList[2].check==true?'check':''">
                <div class="textBox">
                  <p style="height: 48px;">{{$t('label_303')}}</p>
                  <p class="num" style="color:#e60000">{{spotStatusNumList[2].num}}</p>
                </div>
                <div class="checkBox">
                  <el-checkbox label="" v-model="spotStatusNumList[2].check"></el-checkbox>
                </div>
              </div>
              <div class="statusMesBox" :class="spotStatusNumList[3].check==true?'check':''">
                <div class="textBox">
                  <p style="height: 48px;">{{$t('label_307')}}</p>
                  <p class="num" style="color:#e60000">{{spotStatusNumList[3].num}}</p>
                </div>
                <div class="checkBox">
                  <el-checkbox label="" v-model="spotStatusNumList[3].check"></el-checkbox>
                </div>
              </div>
              <div class="statusMesBox" :class="spotStatusNumList[4].check==true?'check':''">
                <div class="textBox">
                  <p style="height: 48px;">{{$t('label_311')}}</p>
                  <p class="num" style="color:#ffb400">{{spotStatusNumList[4].num}}</p>
                </div>
                <div class="checkBox">
                  <el-checkbox label="" v-model="spotStatusNumList[4].check"></el-checkbox>
                </div>
              </div>
              <div class="statusMesBox" :class="spotStatusNumList[5].check==true?'check':''">
                <div class="textBox">
                  <p style="height: 48px;">{{$t('label_314')}}</p>
                  <p class="num" style="color:#e60000">{{spotStatusNumList[5].num}}</p>
                </div>
                <div class="checkBox">
                  <el-checkbox label="" v-model="spotStatusNumList[5].check"></el-checkbox>
                </div>
              </div>
              <div class="statusMesBox" :class="spotStatusNumList[6].check==true?'check':''">
                <div class="textBox">
                  <p style="height: 48px;">{{$t('label_318')}}</p>
                  <p class="num" style="color:#ffb400">{{spotStatusNumList[6].num}}</p>
                </div>
                <div class="checkBox">
                  <el-checkbox label="" v-model="spotStatusNumList[6].check"></el-checkbox>
                </div>
              </div>
              <div class="statusMesBox" :class="spotStatusNumList[7].check==true?'check':''">
                <div class="textBox">
                  <p style="height: 48px;">{{$t('label_829')}}</p>
                  <p class="num" style="color:#3fb393">{{spotStatusNumList[7].num}}</p>
                </div>
                <div class="checkBox">
                  <el-checkbox label="" v-model="spotStatusNumList[7].check"></el-checkbox>
                </div>
              </div>
              <div class="statusMesBox" :class="spotStatusNumList[8].check==true?'check':''">
                <div class="textBox">
                  <p style="height: 48px;">{{$t('label_326')}}</p>
                  <p class="num" style="color:#aeaeae">{{spotStatusNumList[8].num}}</p>
                </div>
                <div class="checkBox">
                  <el-checkbox label="" v-model="spotStatusNumList[8].check"></el-checkbox>
                </div>
              </div>
            </div>
            <div class="spotMes2Box" style="height: calc(100% - 300px);">
              <div class="buttonBox">
                <div>
                  <div class="chooseButton searchButton" @click="xinjian">{{$t('btn_14')}}</div>
                  <div class="chooseButton searchButton" v-if="MenuRoleList.indexOf('200')>=0" @click="showdialog('bei')">{{$t('btn_41')}}</div>
                  <div class="chooseButton searchButton" @click="showdialog('jie')">{{$t('btn_42')}}</div>
                  <div class="chooseButton searchButton" @click="showdialog('feng') " v-if="MenuRoleList.indexOf('201')>=0">{{$t('btn_43')}}</div>
                  <div class="chooseButton searchButton" @click="showdialog('receive')" v-if="MenuRoleList.indexOf('203')>=0">{{$t('btn_44')}}</div>
                  <div class="chooseButton searchButton" @click="back" v-if="MenuRoleList.indexOf('204')>=0">{{$t('btn_48')}}</div>
                  <div class="chooseButton searchButton" @click="closeTask" v-if="MenuRoleList.indexOf('205')>=0">{{$t('btn_49')}}
                  </div>
                  <div class="chooseButton searchButton" @click="showdialog('project')" v-if="MenuRoleList.indexOf('206')>=0">{{$t('btn_38')}}</div>
                  <div class="chooseButton searchButton" @click="repairTaskExportExcel">
                    <i class="el-icon-download"></i>{{$t('btn_10')}}
                  </div>
                </div>
              </div>
              <div>
                <el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @row-click="handleCurrentChangeTreeTime"
                          height="450px" border style="width: 100%;height:100%;margin: 10px 0 0 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                  <!-- <el-table-column type="selection" width="55">
									</el-table-column> -->
                  <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
                  </el-table-column>
                  <el-table-column prop="deviceName" :label="$t('label_593')" align="center" width="300">
                    <template slot-scope="scope">
                      <p class="tableMiTitle">
                        {{scope.row.superior}}<br>
                        {{scope.row.tname}} {{scope.row.ename}}<br>
                        {{scope.row.code}}<br>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="faultPhenomenon" :label="$t('label_348')" align="center">
                  </el-table-column>
                  <el-table-column prop="urgentLevel" :label="$t('label_290')" align="center">
                    <template slot-scope="scope">
                      <!-- <p :style="{'color':urgentLevelStatusList[scope.row.urgentLevel].color}"> -->
                      <p :style="{'color':'red'}">
                        {{showLevel(scope.row.urgentLevel)}}
                        <!-- {{urgentLevelStatusList[scope.row.urgentLevel].text}} -->
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="reportPerson" :label="$t('label_293')" align="center">
                  </el-table-column>
                  <el-table-column prop="stop" :label="$t('label_351')" align="center">
                    <template slot-scope="scope">

                      <p :style="{'color':stopStatusList[scope.row.stop].color}">
                        {{stopStatusList[scope.row.stop].text}}
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="reportTime" :label="$t('label_296')" align="center" width="180">
                  </el-table-column>
                  <el-table-column prop="retentionTime" :label="$t('label_355')" align="center">
                  </el-table-column>
                  <el-table-column prop="status" :label="$t('label_359')" align="center">
                    <template slot-scope="scope">
                      <p :style="{'color':spotStatusNumList[scope.row.status].color}">
                        {{spotStatusNumList[scope.row.status].text}}
                      </p>
                    </template>
                  </el-table-column>
                </el-table>
                <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
                      @parentMethod="search"></Page>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <el-dialog :title="$t('label_363')" :visible.sync="dialogLogin" append-to-body :close-on-click-modal='false' width="600px" top="10%"
               :before-close="handleClose1" custom-class="dialogBox">
      <el-input v-model="receiveList.userName" type="text" :placeholder="$t('input_27')"></el-input>
      <el-input v-model="receiveList.passWord" type="password" :placeholder="$t('input_28')"></el-input>
      <div style="margin-top: 10px;" class="chooseButton sendButton" @click="login">{{$t('label_371')}}</div>
    </el-dialog>

    <el-dialog :title="$t('label_363')" :visible.sync="dialogLogin1" append-to-body :close-on-click-modal='false' width="600px" top="10%"
               :before-close="handleClose2" custom-class="dialogBox">
      <el-input v-model="receiveList.userName" type="text" :placeholder="$t('input_27')"></el-input>
      <el-input v-model="receiveList.passWord" type="password" :placeholder="$t('input_28')"></el-input>
      <el-input v-model="receiveList.idea" type="text" :placeholder="$t('input_30')" v-if="this.receiveList.confirm == '6'">
      </el-input>
      <el-input v-model="receiveList.accord" type="text" :placeholder="$t('input_32')" v-if="this.receiveList.confirm == '6'">
      </el-input>
      <div style="margin-top: 10px;" class="chooseButton sendButton" @click="login1">{{$t('label_371')}}</div>
    </el-dialog>
    <el-dialog :title="$t('label_363')" :visible.sync="dialogLoginF" append-to-body :close-on-click-modal='false' width="600px" top="10%"
               :before-close="handleCloseF" custom-class="dialogBox">
      <el-input v-model="fengxianConfirmData.userName" type="text" :placeholder="$t('input_27')"></el-input>
      <el-input v-model="fengxianConfirmData.passWord" type="password" :placeholder="$t('input_28')"></el-input>
      <div style="margin-top: 10px;" class="chooseButton sendButton" @click="fengxianLogin">{{$t('label_371')}}</div>
    </el-dialog>

    <el-dialog :title="$t('label_287')" :visible.sync="dialogSpotResult" append-to-body :close-on-click-modal='false' width="1600px"
               v-dialogDrag top="1%" :before-close="handleClose" custom-class="dialogBox" class="bbb">
      <div class="dialogBoxMes" style="padding:0 ;height: calc(100% - 20px)">
        <div class="titleMes1" style="justify-content: space-between;">
          <div style="display: flex;">
          </div>
        </div>
        <div class="titleMes1" style="margin-top: 10px">
          <p style="line-height: 40px; width:100px"><span style="color: #ff0000">*</span>{{$t('label_593')}}</p>
          <div style="margin-left: 5px;width:285px">
            <!-- <el-autocomplete style="width:100%" v-model="mainEditList.devicName" :fetch-suggestions="querySearchAsync1"
             placeholder="请输入设备名称" :trigger-on-focus="false" @select="handleSelect4" value-key="name" clearable @clear="clearSearch(4)"
             ref="myAutocomplete4"><i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-autocomplete> -->
            <el-select v-model="mainEditList.devicName" @change="deviceChoose(mainEditList.devicName)" filterable :placeholder="$t('input_34')"
                       style="width: 100%;">
              <el-option v-for="item in this.deviceList" :key="item.id" :label="item.name" :value="`${item.id}&@${item.name}&@${item.superior}&@${item.deptId}&@${item.typeName}`">
              </el-option>
            </el-select>
          </div>
          <div style="margin-left: 20px;min-width: 200px; line-height: 40px; width: 350px">
            <p>{{$t('label_429')}}: {{mainEditList.typeName}}</p>
          </div>
          <div style="margin-left: 10px; line-height: 40px; width: 680px;">
            <p>{{$t('label_161')}}: {{mainEditList.superior}}</p>
          </div>
          <div style="margin-left: 20px; width: 185px; line-height: 40px;">
            <p>{{allList.orderNo}}</p>
          </div>
        </div>
        <div class="titleMes1" style="justify-content: space-between;">
          <div style="display: flex;">
            <p style="line-height: 40px;"><span style="color: #ff0000">*</span>{{$t('label_348')}}</p>
            <div style="margin-left: 10px;height: 40px;line-height: 45px;display: flex;" class="otherInput">
              <el-checkbox-group v-model="mainEditList.faultPhenomenon">
                <div v-for="item in faultPhenomenonList" style="display: inline-flex;width: 140px;">
                  <el-checkbox :label="item.val">{{item.val}}</el-checkbox>
                </div>
                <div style="display: inline-flex;width: 300px;">
                  <el-checkbox :label="$t('label_380')">{{$t('label_380')}}
                    <el-input style="width: 220px;" v-model="mainEditList.fault" :disabled="mainEditList.faultPhenomenon!=''?mainEditList.faultPhenomenon.toString().indexOf($t('label_380'))>=0?false:true:true"></el-input>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
              <div style="margin-left: 10px;">
                <el-popover placement="right" width="550" trigger="click" class="knowpop">
                  <div v-if="mainEditList.equipmentId!=null&&mainEditList.equipmentId!=''">
                    <div class="knowledge" style="width: 100%;height: 420px;">
                      <div class="tableMes2Box" style="margin: 0px 0px 5px 5px;">
                        <p style="margin-top: 5px; width: 80px;">{{$t('label_382')}}</p>
                        <div style="width:calc(100% - 25px)">
                          <el-input v-model="knowledgeSelect2.faultExplain" @change="selectknowledge3(1)"></el-input>
                        </div>
                      </div>
                      <div style="width: 100%;height: 35px; padding-left: 5px;">
                        <el-select v-model="knowledgeSelect2.faultReasonClassify" :placeholder="$t('input_65')" @change="selectknowledge3(0)"
                                   style="width: calc(50% - 5px);">
                          <el-option key="全部" :label="$t('label_272')" value=""></el-option>
                          <el-option v-for="item in cause" :key="item.key" :label="item.val" :value="item.val">
                          </el-option>
                        </el-select>
                        <el-select v-model="knowledgeSelect2.faultReason" :placeholder="$t('input_65')" @change="selectknowledge3(1)">
                          <el-option key="全部" :label="$t('label_272')" value=""></el-option>
                          <el-option v-for="item in causeList" :key="item.key" :label="item.val" :value="item.val">
                          </el-option>
                        </el-select>
                      </div>
                      <div :key="index" :label="item" v-for="(item,index) in knowledgeList2">
                        <div class="knowledgeChild">
                          <span>{{$t('label_389')}}:{{item.faultReason}}</span><span style="width: 180px;">{{$t('label_385')}}:{{item.frequency}}{{$t('label_207')}}</span>
                          <p style="margin: 10px">
                            <!-- 维修时间:{{(item.repairBeginTime==null?'':item.repairBeginTime+'-')+(item.repairEndTime==null?'':item.repairEndTime)}} -->
                            {{$t('label_393')}}: {{item.aveTime}} {{$t('label_395')}}
                          </p>
                          <p style="margin: 10px">{{$t('label_398')}}:{{item.solution}}</p>
                          <p style="margin: 10px">{{$t('label_401')}}:{{item.precaution}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    {{$t('msg_5')}}
                  </div>
                  <i class="el-icon-question" slot="reference" @click="selectknowledge3(0)"></i>
                </el-popover>

              </div>
            </div>
          </div>
        </div>
        <div class="tableMes2" style="margin-top: 10px">
          <div class="tableMes2Box" style="width: 100%;">
            <p style="margin-top: 5px; width: 100px; "><span style="color: #ffffff">*</span>{{$t('label_406')}}</p>
            <div style="margin: 0px 0px 0px 5px;width:100%;">
              <el-input v-model="mainEditList.faultExplain" clearable :rows="2">
              </el-input>
            </div>
          </div>
        </div>
        <div class="proSpotMes aaa" style="margin-bottom: 0px;  padding: 10px 68px 20px 0;">
          <el-steps align-center :active="status.active" :simple="stepsSimple">
            <el-step :title="stepsSimple?$t('label_78'):''">
              <template slot="description">
                <div :class="['steps_div',status.active<1?'steps_div_0':'steps_div_1']">
                  <div><span class="steps_div_span1">{{$t('label_78')}}</span>：<span>{{status.active<1?'--':status.reportPerson}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active<1?'--':$t('label_409')}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<1?'--':status.reportTime}}</span>
                  </div>
                </div>
              </template>
            </el-step>
            <el-step :title="stepsSimple?$t('label_415'):''">
              <template slot="description">
                <div :class="['steps_div',status.active<2?'steps_div_0':'steps_div_1']">
                  <div><span class="steps_div_span1">{{$t('label_415')}}</span>：<span>{{status.active<2?'--':status.dispatcher}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active>=2?$t('label_418'):$t('label_421')}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<2?'--':status.dispatchTime}}</span>
                  </div>
                </div>
              </template>
            </el-step>
            <el-step :title="stepsSimple?$t('label_424'):''">
              <template slot="description">
                <div :class="['steps_div',status.active<3?'steps_div_0':'steps_div_1']">
                  <div><span class="steps_div_span1">{{$t('label_424')}}</span>：<span>{{status.active<3?'--':status.receivingPerson}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active>=3?$t('label_428'):$t('label_430')}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<3?'--':status.orderTime}}</span>
                  </div>
                </div>
              </template>
            </el-step>
            <el-step :title="stepsSimple?$t('label_434'):''">
              <template slot="description">
                <div :class="['steps_div',status.active<4?'steps_div_0':'steps_div_1']">
                  <div><span class="steps_div_span1">{{$t('label_434')}}</span>：<span>{{status.active<4?'--':status.repairman}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active>4?$t('label_438'):status.active==4?$t('label_311'):$t('label_657')}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<4?'--':status.repairBeginTime}}</span>
                  </div>
                </div>
              </template>
            </el-step>
            <el-step :title="stepsSimple?$t('label_444'):''">
              <template slot="description">
                <div :class="['steps_div',status.active<5?'steps_div_0':'steps_div_1']">
                  <div><span class="steps_div_span1">{{$t('label_444')}}</span>：<span>{{status.active<5?'--':status.accepter}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active>=5?(status.active==5?$t('label_318'):$t('label_448')):$t('label_314')}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<5?'--':status.acceptBeginTime}}</span>
                  </div>
                </div>
              </template>
            </el-step>
            <el-step :title="stepsSimple?$t('label_452'):''">
              <template slot="description">
                <div :class="['steps_div',status.active<6?'steps_div_0':'steps_div_1']">
                  <div><span class="steps_div_span1">{{$t('label_452')}}</span>：<span>{{status.active<6?'--':status.repairman}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_412')}}</span>：<span>{{status.active<6?$t('label_657'):$t('label_829')}}</span>
                  </div>
                  <div><span class="steps_div_span1">{{$t('label_147')}}</span>：<span>{{status.active<6?'--':status.acceptEndTime}}</span>
                  </div>
                </div>
              </template>
            </el-step>
          </el-steps>
          <div :class="stepsSimple?'open':'close'" @click="stepsSimple = !stepsSimple">
            <div style="margin-left: 185px;">
              <div></div>
            </div>
          </div>
        </div>
        <div class="treeMes " style="height: calc(100% - 360px); min-height: 410px; padding: 0; ">
          <div class="spotMesBox" style="height: 100%;">
            <el-tabs v-model="mainEditTree" @tab-click="handleClickTree" class="repairClass">
              <el-tab-pane :label="$t('label_456')" name="project">
                <div v-if="quickData=='0'">
                  <div class="tableMes2">
                    <div class="tableMes2Box">
                      <p style="margin-top: 5px;">{{$t('label_293')}}</p>
                      <div style="margin: 0px 20px 0px 5px;width:250px">
                        <el-input :disabled="true" v-model="mainEditList.reportPerson">
                        </el-input>
                      </div>
                    </div>
                    <div class="tableMes2Box">
                      <p style="margin-top: 5px;"><span style="color: #ffffff">*</span>{{$t('label_569')}}</p>
                      <div style="margin: 0px 20px 0px 5px;width:250px">
                        <el-input :disabled="true" v-model="mainEditList.mobile"></el-input>
                      </div>
                    </div>
                    <div class="tableMes2Box">
                      <p style="margin-top: 5px;"><span style="color: #ff0000">*</span>{{$t('label_290')}}</p>
                      <div style="margin: 0px 20px 0px 5px;width:250px">
                        <el-select style="width: 250px;" v-model="mainEditList.urgentLevel" :placeholder="$t('input_44')">
                          <el-option v-for="item in urgentList" :key="item.key" :label="item.val" :value="item.key">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="tableMes2Box" style="width: 400px;">
                      <p style="margin-top: 5px;width: 130px;text-align-last: end;"><span style="color: #ff0000">*</span>{{$t('label_465')}}</p>
                      <div style="margin: 0px 20px 0px 5px;width:250px">
                        <el-select style="width: 250px;" v-model="mainEditList.faultSource" :placeholder="$t('input_45')">
                          <el-option v-for="item in faultList" :key="item.key" :label="item.val" :value="item.key">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                  <div class="tableMes2">
                    <div class="tableMes2Box" style="width: 360px;">
                      <p style="margin-top: 5px;width: 200px;"><span style="color: #ff0000">*</span>{{$t('label_467')}}</p>
                      <div style="margin: 0px 18px 0px 5px;width:180px">
                        <el-radio-group v-model="mainEditList.stop" @change="stopChange">
                          <el-radio-button label="1">{{$t('label_471')}}</el-radio-button>
                          <el-radio-button label="0">{{$t('label_474')}}</el-radio-button>
                        </el-radio-group>
                      </div>
                    </div>
                    <div class="tableMes2Box">
                      <p style="margin-top: 5px;"><span style="color: #ff0000" v-if="mainEditList.stop!=0">*</span>{{$t('label_476')}}</p>
                      <div style="margin: 0px 20px 0px 5px;width:250px">
                        <el-date-picker style="width: 250px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="mainEditList.stopTime"
                                        type="datetime" :placeholder="$t('input_83')" :disabled="mainEditList.stop==0">
                        </el-date-picker>
                      </div>
                    </div>
                    <div class="tableMes2Box">
                      <p style="margin-top: 5px;"><span style="color: #ff0000">*</span>{{$t('label_296')}}</p>
                      <div style="margin: 0px 20px 0px 5px;width:250px">
                        <el-date-picker style="width: 250px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="mainEditList.reportTime"
                                        type="datetime" :placeholder="$t('input_65')">
                        </el-date-picker>
                      </div>
                    </div>
                    <div class="tableMes2Box">
                      <p style="margin-top: 5px;"><span style="color: #ff0000">*</span>{{$t('label_187')}}</p>
                      <div style="margin: 0px 20px 0px 5px;width:250px">
                        <el-date-picker style="width: 250px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="mainEditList.expectTime"
                                        type="datetime" :placeholder="$t('input_90')">
                        </el-date-picker>
                      </div>
                    </div>
                  </div>

                  <div class="tableMes2">
                    <p style="margin-top: 5px;">{{$t('label_484')}}</p>
                    <div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;margin-left: 20px;"
                         v-if="lookFlag!=99">
                      <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :file-list="fileList"
                                 :http-request="upload" :show-file-list="false">
                        <i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
                      </el-upload>
                    </div>
                    <div v-for="(item,index) in mainEditList.faultImg" class="photoNewdiv">
                      <!-- <img v-if="showIcon(item)" style="width: 50px;height: 50px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
                       @click="previewPdf(item)">
                      <img v-if="!showIcon(item)" style="width: 50px;height: 50px;" src="../../../static/img/fileText.png" @click="previewPdf(item)">
                      <i v-if="allList.orderNo==''" class="el-icon-close" style="position:absolute;top:0px;right:-20px;color: #000000; cursor:pointer"
                       @click="removeFaultImg(index)"></i> -->
                      <img v-if="showIcon(item)" class="imgstyle" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
                           @click="previewPdf(item)">
                      <img v-if="!showIcon(item)" class="imgstyle" src="../../../static/img/fileText.png" @click="previewPdf(item)">
                      <i v-if="allList.orderNo==''" class="el-icon-close imgdelect" @click="removeFaultImg(index)"></i>
                      <el-tooltip class="item" effect="dark" :content="showName(item)" placement="bottom-start">
                        <span class="fileName">{{showName(item)}}</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="tableMes2">
                    <div style="margin: auto;">
											<span slot="footer" class="dialog-footer" style="display: flex;">
												<div style="margin-right: 20px;" class="chooseButton sendButton" @click="commit" v-if="lookFlag > 3&& lookFlag !=99">{{$t('btn_50')}}</div>
												<div style="margin-right: 20px;" class="chooseButton sendButton" @click="quick" v-if="MenuRoleList.indexOf('207')>=0 && lookFlag > 2 && lookFlag !=4&& lookFlag !=99">{{$t('label_490')}}</div>
											</span>
                    </div>
                  </div>
                </div>
                <div v-if="quickData=='1'">
                  <div class="tableMes2 proSpotMes" style="margin-bottom: 10px;padding: 10px 68px 20px 0;">
                    <p style="margin-left: 10px;">{{$t('label_492')}}</p>
                    <div style="margin: auto;">
                      <!-- <span slot="footer" class="dialog-footer" style="display: flex;">
                        <div style="margin-right: 20px;" class="chooseButton sendButton">提交并确认
                        </div>
                        <div style="margin-right: 20px;" class="chooseButton sendButton">快速处理
                        </div>
                      </span> -->
                      <div class="close" @click="quickData='0'" v-if="quickData=='1'">
                        <div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tableMes2">
                    <div class="knowledge" style="border: 1px solid black;">
                      <div style="width: 100%;" v-for="(item,index) in knowledgeListNew">
                        <div class="knowledgeChild">
                          <span>{{$t('label_389')}}:{{item.faultReason}}</span><span style="width: 180px;">{{$t('label_385')}}:{{item.frequency}}{{$t('label_207')}}</span>
                          <p style="margin: 10px">
                            <!-- 维修时间:{{(item.repairBeginTime==null?'':item.repairBeginTime+'-')+(item.repairEndTime==null?'':item.repairEndTime)}} -->
                            {{$t('label_393')}}: {{item.aveTime}} {{$t('label_395')}}
                          </p>
                          <p style="margin: 10px">{{$t('label_398')}}:{{item.solution}}</p>
                          <p style="margin: 10px">{{$t('label_401')}}:{{item.precaution}}</p>
                        </div>
                        <div class="knowledgeChild2">
                          <i class="el-icon-remove" style="margin: 20px 0px;color: #ff3300;font-size: 20px" @click="removeKnowledgeListNew(index)"></i>
                        </div>
                      </div>
                    </div>
                    <div class="knowledge" style="width: 50px; padding-top: 80px;">
                      <div @click="goNew" style="width: 40px; height: 30px;background-color: #43c477;border-radius: 5px; cursor: pointer; margin-left: 5px;">
                        <i class="el-icon-d-arrow-left" style="margin: 5px 0 0 9px; font-size: 20px;color: #FFFFFF;"></i>
                      </div>
                    </div>
                    <div class="knowledge">
                      <div>
                        <div class="tableMes2Box" style="margin: 0px 0px 5px 30px;">
                          <p style="margin-top: 5px;margin-right: 20px;">{{$t('label_382')}}</p>
                          <div style="width:487px">
                            <el-input v-model="knowledgeSelect.faultExplain" @change="selectknowledge"></el-input>
                          </div>
                          <div class="buttonBox" style="margin-left: 10px;">
                            <div class="chooseButton searchButton" @click="insert" v-if="lookFlag!=99">{{$t('btn_14')}}</div>
                          </div>
                        </div>
                        <div style="width: 100%;height: 35px; padding-left: 32px;">
                          <el-select v-model="knowledgeSelect.faultReasonClassify" :placeholder="$t('input_65')" @change="selectknowledge">
                            <el-option key="全部" :label="$t('label_272')" value=""></el-option>
                            <el-option v-for="item in cause" :key="item.key" :label="item.val" :value="item.val">
                            </el-option>
                          </el-select>
                          <el-select v-model="knowledgeSelect.faultReason" :placeholder="$t('input_65')" @change="selectknowledge2">
                            <el-option key="全部" :label="$t('label_272')" value=""></el-option>
                            <el-option v-for="item in causeList" :key="item.key" :label="item.val" :value="item.val">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                      <div style="height: 155px;overflow-y: auto;">
                        <div style="width: 100%;height:100%">
                          <el-checkbox-group style="width: 100%;height: auto;" v-model="knowledgeCheckList">
                            <el-checkbox :key="index" :label="item" v-for="(item,index) in knowledgeList">
                              <div class="knowledgeChild">
                                <span>{{$t('label_389')}}:{{item.faultReason}}</span><span style="width: 180px;">{{$t('label_385')}}:{{item.frequency}}{{$t('label_207')}}</span>
                                <p style="margin: 10px">
                                  <!-- 维修时间:{{(item.repairBeginTime==null?'':item.repairBeginTime+'-')+(item.repairEndTime==null?'':item.repairEndTime)}} -->
                                  {{$t('label_393')}}: {{item.aveTime}} {{$t('label_395')}}
                                </p>
                                <p style="margin: 10px">{{$t('label_398')}}:{{item.solution}}</p>
                                <p style="margin: 10px">{{$t('label_401')}}:{{item.precaution}}</p>
                              </div>
                            </el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tableMes2">
                    <p style="margin-top: 5px;">{{$t('label_484')}}</p>
                    <div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;margin-left: 20px;"
                         v-if="lookFlag!=99">
                      <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :file-list="fileList"
                                 :http-request="upload2" :show-file-list="false">
                        <i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
                      </el-upload>
                    </div>
                    <div v-for="(item,index) in mainEditList.repairImg" class="photoNewdiv">
                      <!-- <img v-if="showIcon(item)" style="width: 50px;height: 50px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
                       @click="previewPdf(item)">
                      <img v-if="!showIcon(item)" style="width: 50px;height: 50px;" src="../../../static/img/fileText.png" @click="previewPdf(item)">
                      <i v-if="allList.status=='1'" class="el-icon-close" style="position:absolute;top:0px;right:-20px;color: #000000; cursor:pointer"
                       @click="removeFaultImg2(index)"></i> -->


                      <img v-if="showIcon(item)" class="imgstyle" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
                           @click="previewPdf(item)">
                      <img v-if="!showIcon(item)" class="imgstyle" src="../../../static/img/fileText.png" @click="previewPdf(item)">
                      <i v-if="allList.status=='1'" class="el-icon-close imgdelect" @click="removeFaultImg2(index)"></i>
                      <el-tooltip class="item" effect="dark" :content="showName(item)" placement="bottom-start">
                        <span class="fileName">{{showName(item)}}</span>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="tableMes2">
                    <div style="margin: auto;">
											<span slot="footer" class="dialog-footer" style="display: flex;">
												<div class="chooseButton sendButton" @click="save(4)">{{$t('btn_39')}}</div>
											</span>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="$t('label_415')" name="bei">
                <div>
                  <div class="tableMes2">
                    <p style="margin-top: 5px;" v-if="allList.cause!=null&&allList.cause!=''">{{$t('label_512')}}: {{allList.cause}}</p>
                  </div>
                  <div class="tableMes2">
                    <div class="tableMes2Box" style="width: 550px;">
                      <p style="margin-top: 5px;">{{$t('label_514')}}: {{allList.dispatchTime}}</p>
                    </div>
                    <div class="tableMes2Box" style="margin: 0px 20px 0px -35px;">
                      <p style="margin-right: 10px; margin-top: -4px;"><span style="color: #ff0000">*</span>{{$t('label_516')}}</p>
                      <el-checkbox-group v-model="tableDataEdit.repairMode">
                        <el-checkbox v-for="item in malfunctionList" :label="item.val" :key="item.val"></el-checkbox>
                      </el-checkbox-group>
                      <!-- 添加厂家选择下拉框，向右移动并减小宽度 -->
                      <div v-if="isManufacturerRepair" style="margin: -8px 0 0 10px; display: inline-block;">
                        <span style="margin-right: -5px; font-size: 15px">{{$t('label_1020')}}</span>
                         <!-- <p style="margin-right: 10px; font-size: 15px">{{$t('label_1020')}}</p> -->
                        <el-select v-model="tableDataEdit.manufacturer" :placeholder="$t('msg_244')" style="width: 150px; height: 22px;">
                          <el-option
                            v-for="manufacturer in manufacturerList"
                            :key="manufacturer.name"
                            :label="manufacturer.name"
                            :value="manufacturer.name">
                          </el-option>
                        </el-select>
                      </div>
                      <!-- 添加外协选择下拉框，向右移动并减小宽度 -->
                      <div v-if="isOutsourcingRepair" style="margin: -8px 0 0 10px; display: inline-block;">
                        <span style="margin-right: -5px;font-size: 15px">{{$t('label_1021')}}</span>
                        <!-- <p style="margin-right:10px;">{{$t('label_1021')}}</p> -->
                        <el-select v-model="tableDataEdit.outsourcing" :placeholder="$t('msg_245')" style="width: 180px; height: 32px;">
                          <el-option
                            v-for="outsourcing in outsourcingList"
                            :key="outsourcing.name"
                            :label="outsourcing.name"
                            :value="outsourcing.name">
                          </el-option>
                        </el-select>
                      </div>
                      <!-- <el-radio-group v-model="tableDataEdit.repairMode" style="margin-top: 5px;">
                        <el-radio v-for="item in malfunctionList" :label="item.val" :key="item.val"></el-radio>
                      </el-radio-group> -->
                    </div>
                  </div>
                  <div class="tableMes2">
                    <div class="tableMes2Box" style="width: 700px;">
                      <p style="margin-top: 5px;margin-right: 10px;width: 80px;word-break:keep-all;width: 180px; ">
                        {{$t('label_518')}}</p>
                      <el-checkbox-group v-model="tableDataEdit.risk" style="margin-top: 5px;">
                        <el-checkbox v-for="item in riskList" :label="item" :key="item"></el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <div class="tableMes2Box" style="margin: 0px 20px 0px 0px;">
                      <p style="margin-right: 10px;"><span style="color: #ff0000">*</span>{{$t('label_521')}}</p>
                      <!-- <el-checkbox-group v-model="tableDataEdit.faultLevel">
												<el-checkbox v-for="item in maintainList" :label="item.val" :key="item.val"></el-checkbox>
											</el-checkbox-group> -->
                      <el-radio-group v-model="tableDataEdit.faultLevel" style="margin-top: 5px;">
                        <el-radio v-for="item in maintainList" :label="item.val" :key="item.val"></el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                  <div class="tableMes2">
                    <!-- <div class="tableMes2Box">
											<p style="margin-top: 5px;width: 80px;">维修人</p>
											<div style="margin:0px 20px 0px 10px;width:250px">
												<el-autocomplete style="width:100%" v-model="tableDataEdit.repairman" :fetch-suggestions="querySearchAsync"
												 placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect" value-key="fullName" clearable @clear="clearSearch(1)"
												 ref="myAutocomplete"><i slot="suffix" class="el-input__icon el-icon-search"></i></el-autocomplete>
											</div>
										</div> -->
                    <div class="tableMes2Box">
                      <p style="margin-top: 5px;width: 120px;"><span style="color: #ff0000">*</span>{{$t('label_523')}}</p>
                      <div style="margin:0px 20px 0px 10px;width:250px">
                        <el-select v-model="selectValue" filterable :placeholder="$t('input_66')" :remote-method="remoteMethod" :loading="loading">
                          <el-option v-for="item in options" :key="item.id" :label="item.fullName" :value="`${item.id}&@${item.fullName}`">
                            <span style="float: left">{{item.fullName}}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{item.repairTaskNum}}</span>
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="tableMes2Box">
                      <p style="margin-top: 5px;width: 80px;"><span style="color: #ff0000">*</span>{{$t('label_527')}}</p>
                      <div style="margin:0px 20px 0px 10px;width:250px">
                        <el-select v-model="selectValue3" filterable :placeholder="$t('input_66')" :remote-method="remoteMethod3" :loading="loading">
                          <el-option v-for="item in options3" :key="item.id" :label="item.fullName" :value="`${item.id}&@${item.fullName}`">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <!-- <div class="tableMes2Box">
											<p style="margin-top: 5px;">验收人</p>
											<div style="margin: 0px 20px 0px 5px;width:250px">
												<el-autocomplete style="width:100%" v-model="tableDataEdit.accepter" :fetch-suggestions="querySearchAsync"
												 placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect2" value-key="fullName" clearable
												 @clear="clearSearch(2)" ref="myAutocomplete2"></el-autocomplete>
											</div>
										</div> -->
                    <!-- <div class="tableMes2Box">
											<p style="margin-top: 5px;">参与人</p>
											<div style="margin: 0px 20px 0px 5px;width:250px">
												<el-autocomplete style="width:100%" v-model="tableDataEdit.participants" :fetch-suggestions="querySearchAsync"
												 placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect3" value-key="fullName" clearable
												 @clear="clearSearch(3)" ref="myAutocomplete3"><i slot="suffix" class="el-input__icon el-icon-search"></i></el-autocomplete>
											</div>
										</div> -->
                    <div class="tableMes2Box">
                      <p style="margin-top: 5px;width: 80px;"><span style="color: #ff0000">*</span>{{$t('label_530')}}</p>
                      <div style="margin:0px 20px 0px 10px;width:250px">
                        <el-select v-model="selectValue2" multiple filterable :placeholder="$t('input_66')" :remote-method="remoteMethod2"
                                   :loading="loading">
                          <el-option v-for="item in options2" :key="item.id" :label="item.fullName" :value="`${item.id}&@${item.fullName}`">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="tableMes2Box">
                      <p style="margin-top: 5px;width: 130px;">{{$t('label_532')}}</p>
                      <div style="margin:5px 20px 0px 10px;width:250px">
                        <el-switch v-model="valueOpenClose" active-color="#13ce66" inactive-color="#808080"></el-switch>
                      </div>
                    </div>
                  </div>
                  <div class="tableMes2">
                    <div class="tableMes2Box" style="width: 100%;">
                      <p style="margin-top: 5px; width: 85px;">{{$t('btn_29')}}</p>
                      <div style="margin: 0px 0px 0px 5px;width:100%">
                        <el-input v-model="tableDataEdit.remarks" type="textarea" :rows="4">
                        </el-input>
                      </div>
                    </div>
                  </div>
                  <div class="tableMes2">
                    <div style="margin: auto;">
											<span slot="footer" class="dialog-footer" style="display: flex;">
												<div style="margin-right: 20px;" class="chooseButton sendButton" @click="fengxianlihui" v-if="valueOpenClose==true && lookFlag > 2 && showLiHui">{{$t('label_535')}}</div>
												<div style="margin-right: 20px;" class="chooseButton sendButton" @click="save(1)" v-if="MenuRoleList.indexOf('200')>=0 && lookFlag > 2 && allList.status == '1'&& lookFlag !=99">{{$t('btn_41')}}</div>
												<div style="margin-right: 20px;" class="chooseButton sendButton" @click="save(2)" v-if="lookFlag > 2 && allList.status == '2'">{{$t('btn_42')}}</div>
											</span>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="$t('label_287')" name="feng" style="height: 100%;">
                <el-tabs tab-position="left" v-model="mainEditSheet" @tab-click="handleClick0" class="fengxianfenxi" style="height: 100%;">
                  <el-tab-pane :label="$t('label_543')" name="feng1" style="height: 390px" v-if="receiveList.confirm != '99'&& lookFlag!= 99&&(allList.status==3||allList.status==4)">
                    <el-checkbox-group v-model="riskConfrimData" style="min-height: 240px;">
                      <el-tabs type="border-card" v-model="fengModelHead">
                        <template v-for="item in riskConfrimList">
                          <el-tab-pane :label="item.head" :name="item.head">
                            <div class="riskLiskBox">
                              <template v-for="checkItem in item.rkList">
                                <div class="ridk">
                                  <el-checkbox :label="checkItem.id" border>{{checkItem.content}}</el-checkbox>
                                </div>
                              </template>
                            </div>
                          </el-tab-pane>
                        </template>
                      </el-tabs>
                    </el-checkbox-group>
                    <!-- {{allList.distinction}} -->
                    <div style="margin-left: 280px;border: 1px solid #CCCCCC; width: 900px; height: 130px;margin-top: 30px;display: flex;"
                         v-if="allList.distinction<2">
                      <div class="querendiv3" v-if="MenuRoleList.indexOf('128')>=0">
                        <div class="querendiv" @click="getRiskList2(1)">
                          {{$t('label_544')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph1 == null||allList.confirm<1)}" @click="receive(1)">
                          <span v-if="allList.autograph1 == null||allList.confirm<1">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph1 != null && allList.autograph1.length < 50&&allList.confirm>0">{{allList.autograph1}}</span>
                          <img v-if="allList.autograph1 != null && allList.autograph1.length > 50&&allList.confirm>0" :src="allList.autograph1"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                      <div class="querendiv3" v-if="MenuRoleList.indexOf('129')>=0">
                        <div class="querendiv" @click="getRiskList2(2)">
                          {{$t('label_548')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph2 == null||allList.confirm<2)}" @click="receive(2)">
                          <span v-if="allList.autograph2 == null||allList.confirm<2">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph2 != null && allList.autograph2.length < 50&&allList.confirm>1">{{allList.autograph2}}</span>
                          <img v-if="allList.autograph2 != null && allList.autograph2.length > 50&&allList.confirm>1" :src="allList.autograph2"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                      <div class="querendiv3" v-if="MenuRoleList.indexOf('130')>=0">
                        <div class="querendiv" @click="getRiskList2(3)">
                          {{$t('label_551')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph3 == null||allList.confirm<3)}" @click="receive(3)">
                          <span v-if="allList.autograph3 == null||allList.confirm<3">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph3 != null && allList.autograph3.length < 50&&allList.confirm>2">{{allList.autograph3}}</span>
                          <img v-if="allList.autograph3 != null && allList.autograph3.length > 50&&allList.confirm>2" :src="allList.autograph3"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                      <div class="querendiv3" v-if="MenuRoleList.indexOf('131')>=0">
                        <div class="querendiv" @click="getRiskList2(4)">
                          {{$t('label_553')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph4 == null||allList.confirm<4)}" @click="receive(4)">
                          <span v-if="allList.autograph4 == null||allList.confirm<4">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph4 != null && allList.autograph4.length < 50&&allList.confirm>3">{{allList.autograph4}}</span>
                          <img v-if="allList.autograph4 != null && allList.autograph4.length > 50&&allList.confirm>3" :src="allList.autograph4"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                      <div class="querendiv3" v-if="allList.distinction == '0' && MenuRoleList.indexOf('422')>=0">
                        <div class="querendiv">
                          {{$t('label_556')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph5 == null||allList.confirm<5)}" @click="receive(5)">
                          <span v-if="allList.autograph5 == null||allList.confirm<5">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph5 != null && allList.autograph5.length < 50&&allList.confirm>4">{{allList.autograph5}}</span>
                          <img v-if="allList.autograph5 != null && allList.autograph5.length > 50&&allList.confirm>4" :src="allList.autograph5"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('label_727')" name="feng2" style="height: 390px">
                    <P style="margin-left: 11px;">{{$t('label_560')}}</P>
                    <P style="margin-left: 11px;">{{$t('label_564')}}</P>
                    <P style="margin-left: 11px;">{{$t('label_568')}}</P>
                    <div class="tableMes2 ">
                      <div class="tableMes2Box" style="margin-left: 10px;">
                        <p style="margin-right: 10px;width: 100px;"><span style="color: #ff0000">*</span>{{$t('label_516')}}</p>
                        <!-- <el-radio-group v-model="tableDataEdit.repairMode" style="margin-top: 5px;">
													<el-radio v-for="item in malfunctionList" :label="item.val" :key="item.val" disabled></el-radio>
												</el-radio-group> -->
                        <el-checkbox-group v-model="tableDataEdit.repairMode">
                          <el-checkbox v-for="item in malfunctionList" :label="item.val" :key="item.val"></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div class="tableMes2">
                      <div class="tableMes2Box" style="margin-left: 10px;width: 50%;">
                        <p style="margin-right: 10px;width: 80px;word-break:keep-all;width: 180px; ">{{$t('label_518')}}</p>
                        <el-checkbox-group v-model="tableDataEdit.risk" style="margin-top: 5px;">
                          <el-checkbox v-for="item in riskList" :label="item" :key="item" disabled>
                          </el-checkbox>
                        </el-checkbox-group>
                      </div>
                      <div class="tableMes2Box" style="width: 50%;">
                        <p style="margin-right: 10px;">{{$t('label_521')}}</p>
                        <el-radio-group v-model="tableDataEdit.faultLevel" style="margin-top: 5px;">
                          <el-radio v-for="item in maintainList" :label="item.val" :key="item.val" disabled></el-radio>
                        </el-radio-group>
                      </div>
                    </div>
                    <div class="tableMes2">
                      <div class="tableMes2Box" style="margin-left: 10px;">
                        <p style="margin-top: 5px; width: 185px;"><span style="color: #ff0000">*</span>{{$t('msg_64')}}</p>
                        <div style="margin: 0px 20px 0px 5px;width:215px">
                          <el-radio-group v-model="tableDataEdit.needAccepter" size="medium">
                            <el-radio-button label="1">{{$t('label_471')}}</el-radio-button>
                            <el-radio-button label="0">{{$t('label_474')}}</el-radio-button>
                          </el-radio-group>
                        </div>
                      </div>
                      <div class="tableMes2Box" style="margin-left: 10px;">
                        <p style="margin-top: 5px; width: 220px;"><span style="color: #ff0000">*</span>{{$t('msg_65')}}</p>
                        <div style="margin: 0px 20px 0px 5px;width:215px">
                          <el-radio-group v-model="tableDataEdit.needAccuracy" size="medium">
                            <el-radio-button label="1">{{$t('label_471')}}</el-radio-button>
                            <el-radio-button label="0">{{$t('label_474')}}</el-radio-button>
                          </el-radio-group>
                        </div>
                      </div>
                    </div>
                    <div class="tableMes2">
                      <div class="tableMes2Box abc" style="margin-left: 10px;overflow:auto;width: 100%;">
                        <p style="margin-top: 5px; width: 150px;"><span style="color: #ff0000">*</span>{{$t('label_575')}}</p>
                        <div style="width: calc(100% - 200px);">
                          <el-checkbox-group v-model="checkList100" @change="setMealSelect1" style="margin-left: 5px;">
                            <el-checkbox label="0">{{$t('label_577')}}</el-checkbox>
                            <el-checkbox label="1">{{$t('label_579')}}
                              <el-input class="otherInput" v-model="tableDataEdit.delayedDay" :disabled="tableDataEdit.other?false:true"></el-input>
                            </el-checkbox>
                          </el-checkbox-group>
                        </div>

                      </div>
                    </div>
                    <div class="tableMes2">
                      <div class="tableMes2Box abc" style="margin-left: 10px;">
                        <p style="margin-right: 10px;width: 100px;"><span style="color: #ff0000" v-if="tableDataEdit.other?true:false">*</span>{{$t('label_582')}}</p>
                        <div style="margin-top: 5px;">
                          <el-checkbox-group v-model="tableDataEdit.reason" :disabled="tableDataEdit.other?false:true">
                            <el-checkbox v-for="item in delayedList" :label="item.val" :key="item.val"></el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <el-checkbox :label="$t('label_380')" v-model="tableDataEdit.other1" :disabled="tableDataEdit.other?false:true" style="margin-left: 10px;">{{$t('label_380')}}
                          <el-input class="otherInput" v-model="tableDataEdit.otherInput" :disabled="tableDataEdit.other1?false:true"></el-input>
                        </el-checkbox>
                      </div>
                    </div>
                    <div class="tableMes2">
                      <div style="margin-left: 10px;">
                        <p style="margin-right: 10px;width: 100px;"><span style="color: #ff0000">*</span>{{$t('label_584')}}</p>
                      </div>
                    </div>
                    <div class="tableMes2">
                      <div class="knowledge" style="border: 1px solid black; ">
                        <div style="width: 99%;height: auto;" v-for="(item,index) in knowledgeListNew">
                          <div class="knowledgeChild">
                            <span>{{$t('label_389')}}:{{item.faultReason}}</span><span style="width: 180px;">{{$t('label_385')}}:{{item.frequency}}次</span>
                            <p style="margin: 10px">
                              <!-- 维修时间:{{(item.repairBeginTime==null?'':item.repairBeginTime+'-')+(item.repairEndTime==null?'':item.repairEndTime)}} -->
                              {{$t('label_393')}}: {{item.aveTime}} {{$t('label_395')}}
                            </p>
                            <p style="margin: 10px">{{$t('label_398')}}:{{item.solution}}</p>
                            <p style="margin: 10px">{{$t('label_401')}}:{{item.precaution}}</p>
                          </div>
                          <div class="knowledgeChild2">
                            <i class="el-icon-remove" style="margin: 20px 0px;color: #ff3300;font-size: 20px" @click="removeKnowledgeListNew(index)"></i>
                          </div>
                        </div>
                      </div>
                      <div class="knowledge" style="width: 50px; padding-top: 80px;">
                        <div @click="goNew" style="width: 40px; height: 30px;background-color: #43c477;border-radius: 5px; cursor: pointer; margin-left: 5px;">
                          <i class="el-icon-d-arrow-left" style="margin: 5px 0 0 9px; font-size: 20px;color: #FFFFFF;"></i>
                        </div>
                      </div>
                      <div class="knowledge">
                        <div>
                          <div class="tableMes2Box" style="margin: 0px 0px 5px 30px;">
                            <p style="margin-top: 5px; width: 80px;">{{$t('label_382')}}</p>
                            <div style="width:405px">
                              <el-input v-model="knowledgeSelect.faultExplain" @change="selectknowledge"></el-input>
                            </div>
                            <div class="buttonBox" style="margin-left: 10px;">
                              <div class="chooseButton searchButton" @click="insert" v-if="lookFlag!=99">{{$t('btn_14')}}</div>
                            </div>
                          </div>
                          <div style="width: 100%;height: 35px; padding-left: 32px;">
                            <el-select v-model="knowledgeSelect.faultReasonClassify" :placeholder="$t('input_65')" @change="selectknowledge">
                              <el-option key="全部" :label="$t('label_272')" value=""></el-option>
                              <el-option v-for="item in cause" :key="item.key" :label="item.val" :value="item.val">
                              </el-option>
                            </el-select>
                            <el-select v-model="knowledgeSelect.faultReason" :placeholder="$t('input_65')" @change="selectknowledge2">
                              <el-option key="全部" :label="$t('label_272')" value=""></el-option>
                              <el-option v-for="item in causeList" :key="item.key" :label="item.val" :value="item.val">
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                        <div style="height: 155px;overflow-y: auto;">
                          <div style="width: 100%;height:100%">
                            <el-checkbox-group style="width: 100%;height: auto;" v-model="knowledgeCheckList">
                              <el-checkbox :key="index" :label="item" v-for="(item,index) in knowledgeList">
                                <div class="knowledgeChild">
                                  <span>{{$t('label_389')}}:{{item.faultReason}}</span><span style="width: 180px;">{{$t('label_385')}}:{{item.frequency}}{{$t('label_207')}}</span>
                                  <p style="margin: 10px">
                                    <!-- 维修时间:{{(item.repairBeginTime==null?'':item.repairBeginTime+'-')+(item.repairEndTime==null?'':item.repairEndTime)}} -->
                                    {{$t('label_393')}}: {{item.aveTime}} {{$t('label_395')}}
                                  </p>
                                  <p style="margin: 10px">{{$t('label_398')}}:{{item.solution}}</p>
                                  <p style="margin: 10px">{{$t('label_401')}}:{{item.precaution}}</p>
                                </div>
                              </el-checkbox>
                            </el-checkbox-group>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tableMes2">
                      <p style="margin-top: 5px;">{{$t('label_484')}}</p>
                      <div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;margin-left: 20px;"
                           v-if="lookFlag!=99">
                        <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :file-list="fileList"
                                   :http-request="upload2" :show-file-list="false">
                          <i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
                        </el-upload>
                      </div>
                      <div v-for="(item,index) in mainEditList.repairImg" class="photoNewdiv">
                        <!-- <img v-if="showIcon(item)" style="width: 50px;height: 50px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
												 @click="previewPdf(item)">
												<img v-if="!showIcon(item)" style="width: 50px;height: 50px;" src="../../../static/img/fileText.png" @click="previewPdf(item)">
												<i v-if="allList.status=='3'||allList.status=='4'" class="el-icon-close" style="position:absolute;top:0px;right:-20px;color: #000000; cursor:pointer"
												 @click="removeFaultImg2(index)"></i> -->

                        <img v-if="showIcon(item)" class="imgstyle" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+item"
                             @click="previewPdf(item)">
                        <img v-if="!showIcon(item)" class="imgstyle" src="../../../static/img/fileText.png" @click="previewPdf(item)">
                        <i v-if="allList.status=='3'||allList.status=='4'" class="el-icon-close imgdelect" @click="removeFaultImg2(index)"></i>
                        <el-tooltip class="item" effect="dark" :content="showName(item)" placement="bottom-start">
                          <span class="fileName">{{showName(item)}}</span>
                        </el-tooltip>
                      </div>
                    </div>
                    <div class="tableMes2" v-if="((receiveList.confirm == '5'&&allList.distinction=='1') || receiveList.confirm == '99'||(receiveList.confirm == '4'&&allList.distinction=='1'))||(allList.appointMeet == '1'&&allList.distinction=='1' && allList.confirm == '4')">
                      <div style="margin: auto;">
												<span slot="footer" class="dialog-footer" style="display: flex;">
													<div class="chooseButton sendButton" style="margin-right: 20px;" @click="save(5)" v-if="lookFlag > 1 && (allList.status=='3'||allList.status=='4')">{{$t('label_591')}}</div>
													<div class="chooseButton sendButton" @click="save(3)" v-if="lookFlag > 1 && (allList.status=='3'||allList.status=='4')">{{$t('btn_39')}}</div>
												</span>
                      </div>
                    </div>
                    <div style="margin-left: 280px;border: 1px solid #CCCCCC; width: 900px; height: 130px;display: flex;" v-if="receiveList.distinction == '2'">
                      <div class="querendiv3">
                        <div class="querendiv">
                          {{$t('label_544')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph1 == null||allList.confirm<1)}" @click="receive(1)">
                          <span v-if="allList.autograph1 == null||allList.confirm<1">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph1 != null && allList.autograph1.length < 50&&allList.confirm>0">{{allList.autograph1}}</span>
                          <img v-if="allList.autograph1 != null && allList.autograph1.length > 50&&allList.confirm>0" :src="allList.autograph1"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                      <div class="querendiv3">
                        <div class="querendiv">
                          {{$t('label_548')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph2 == null||allList.confirm<2)}" @click="receive(2)">
                          <span v-if="allList.autograph2 == null||allList.confirm<2">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph2 != null && allList.autograph2.length < 50&&allList.confirm>1">{{allList.autograph2}}</span>
                          <img v-if="allList.autograph2 != null && allList.autograph2.length > 50&&allList.confirm>1" :src="allList.autograph2"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                      <div class="querendiv3">
                        <div class="querendiv">
                          {{$t('label_551')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph3 == null||allList.confirm<3)}" @click="receive(3)">
                          <span v-if="allList.autograph3 == null||allList.confirm<3">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph3 != null && allList.autograph3.length < 50&&allList.confirm>2">{{allList.autograph3}}</span>
                          <img v-if="allList.autograph3 != null && allList.autograph3.length > 50&&allList.confirm>2" :src="allList.autograph3"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                      <div class="querendiv3">
                        <div class="querendiv">
                          {{$t('label_553')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph4 == null||allList.confirm<4)}" @click="receive(4)">
                          <span v-if="allList.autograph4 == null||allList.confirm<4">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph4 != null && allList.autograph4.length < 50&&allList.confirm>3">{{allList.autograph4}}</span>
                          <img v-if="allList.autograph4 != null && allList.autograph4.length > 50&&allList.confirm>3" :src="allList.autograph4"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                      <div class="querendiv3" v-if="receiveList.distinction == '2'&&allList.appointMeet != '1'">
                        <div class="querendiv">
                          {{$t('label_556')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph5 == null||allList.confirm<5)}" @click="receive(5)">
                          <span v-if="allList.autograph5 == null||allList.confirm<5">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph5 != null && allList.autograph5.length < 50&&allList.confirm>4">{{allList.autograph5}}</span>
                          <img v-if="allList.autograph5 != null && allList.autograph5.length > 50&&allList.confirm>4" :src="allList.autograph5"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                      <div class="querendiv3" v-if="receiveList.distinction == '2'&&allList.appointMeet == '1'">
                        <div class="querendiv">
                          {{$t('label_594')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph5 == null||allList.confirm<5)}" @click="receive(5)">
                          <span v-if="allList.autograph5 == null||allList.confirm<5">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph5 != null && allList.autograph5.length < 50&&allList.confirm>4">{{allList.autograph5}}</span>
                          <img v-if="allList.autograph5 != null && allList.autograph5.length > 50&&allList.confirm>4" :src="allList.autograph5"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                      <div class="querendiv3" v-if="receiveList.distinction == '2'&&allList.appointMeet == '1'">
                        <div class="querendiv">
                          {{$t('label_556')}}</div>
                        <div class="querendiv2" :class="{'querendiv4':!(allList.autograph9 == null||allList.confirm<6)}" @click="receive(9)">
                          <span v-if="allList.autograph9 == null||allList.confirm<6">{{$t('label_546')}}</span>
                          <span v-if="allList.autograph9 != null && allList.autograph9.length < 50&&allList.confirm>5">{{allList.autograph9}}</span>
                          <img v-if="allList.autograph9 != null && allList.autograph9.length > 50&&allList.confirm>5" :src="allList.autograph9"
                               width="30%" height="80%" style="transform: rotate(270deg);">
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('label_597')" name="feng3" style="height: 390px">
                    <div class="tabBbox" style="height: 390px">
                      <partInfo ref="partInfoDisplay" :show="lookFlag"></partInfo>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('label_600')" name="feng4" style="height: 100%" v-if="receiveList.confirm != '99'">
                    <div class="tabBbox" style="height: 100%" v-if="this.allList.appointMeet == 1">
                      <div class="buttonBox" style="width: 100%; ">
                        <div class="chooseButton searchButton" @click="riskExcel">{{$t('btn_51')}}</div>
                        <div class="block" style="margin-left: 20px;">
                          <el-date-picker v-model="fengxianlihuiTime1" type="datetime" :placeholder="$t('input_89')" value-format="yyyy-MM-dd HH:mm:ss"
                                          format="yyyy-MM-dd HH:mm:ss" @change="fengTime">
                          </el-date-picker>
                          -
                          <el-date-picker v-model="fengxianlihuiTime2" type="datetime" :placeholder="$t('input_89')" value-format="yyyy-MM-dd HH:mm:ss"
                                          format="yyyy-MM-dd HH:mm:ss" @change="fengTime">
                          </el-date-picker>
                        </div>
                      </div>
                      <div style="margin-top: 10px;">
                        <span style="font-size: 16px;">1、{{$t('label_605')}}</span>
                        <span style="font-size: 12px;font-weight: bold;"></span>
                      </div>
                      <el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data1" highlight-current-row :span-method="objectSpanMethod1" border
                                style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                        <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex1" width="50">
                        </el-table-column>
                        <el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left" width="400">
                        </el-table-column>
                        <el-table-column v-for="(day,index) in feng4Date1" :key="index" :label="getLable1(index)" align="center"
                                         :width="150">
                          <el-table-column :prop="day" :label="day.substring(8,16).replace(' ', $t('label_537'))" width="120" align="center">
                            <template slot-scope="scope">
                              <p v-for="(name,index) in scope.row[day].split(',data:image/')">
                                <span v-if="name.length<50">{{name=='1'?'✔':name=='0'?'✖':name}}</span>
                                <span v-if="name.length>50">
																	<img :src="(index==0?'':'data:image/')+name" style="transform: rotate(270deg); width: 60px;height: 60px;"
                                       @click="showImg2((index==0?'':'data:image/')+name)" />
																</span>
                              </p>
                            </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                      <div style="margin-top: 10px;">
                        <span style="font-size: 16px;">2、{{$t('label_683')}}</span>
                        <span style="font-size: 12px;font-weight: bold;">{{$t('label_685')}}</span>
                      </div>
                      <el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data2" highlight-current-row :span-method="objectSpanMethod2" border
                                style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                        <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex2" width="50">
                        </el-table-column>
                        <el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left" width="400">
                        </el-table-column>
                        <el-table-column v-for="(day,index) in feng4Date2" :key="index" :label="getLable1(index)" align="center"
                                         :width="150">
                          <el-table-column :prop="day" :label="day.substring(8,16).replace(' ', $t('label_537'))" width="120" align="center">
                            <template slot-scope="scope">
                              <p v-for="(name,index) in scope.row[day].split(',data:image/')">
                                <span v-if="name.length<50">{{name=='1'?'✔':name=='0'?'✖':name}}</span>
                                <span v-if="name.length>50">
																	<img :src="(index==0?'':'data:image/')+name" style="transform: rotate(270deg); width: 60px;height: 60px;"
                                       @click="showImg2((index==0?'':'data:image/')+name)" />
																</span>
                              </p>
                            </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                      <div style="margin-top: 10px;">
                        <span style="font-size: 16px;">3、{{$t('label_688')}}</span>
                        <span style="font-size: 12px;font-weight: bold;">{{$t('msg_69')}}</span>
                      </div>
                      <el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data3" highlight-current-row :span-method="objectSpanMethod3" border
                                style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                        <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex3" width="50">
                        </el-table-column>
                        <el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left" width="400">
                        </el-table-column>
                        <el-table-column v-for="(day,index) in feng4Date3" :key="index" :label="getLable1(index)" align="center"
                                         :width="150">
                          <el-table-column :prop="day" :label="day.substring(8,16).replace(' ', $t('label_537'))" width="120" align="center">
                            <template slot-scope="scope">
                              <p v-for="(name,index) in scope.row[day].split(',data:image/')">
                                <span v-if="name.length<50">{{name=='1'?'✔':name=='0'?'✖':name}}</span>
                                <span v-if="name.length>50">
																	<img :src="(index==0?'':'data:image/')+name" style="transform: rotate(270deg); width: 60px;height: 60px;"
                                       @click="showImg2((index==0?'':'data:image/')+name)" />
																</span>
                              </p>
                            </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                      <div style="margin-top: 10px;">
                        <span style="font-size: 16px;">4、{{$t('label_693')}}</span>
                        <span style="font-size: 12px;font-weight: bold;"></span>
                      </div>
                      <el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data4" highlight-current-row :span-method="objectSpanMethod4" border
                                style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                        <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex4" width="50">
                        </el-table-column>
                        <el-table-column prop="item" :label="$t('label_678')" header-align="center" align="left" width="400">
                        </el-table-column>
                        <el-table-column v-for="(day,index) in feng4Date4" :key="index" :label="getLable1(index)" align="center"
                                         :width="150">
                          <el-table-column :prop="day" :label="day.substring(8,16).replace(' ', $t('label_537'))" width="120" align="center">
                            <template slot-scope="scope">
                              <p v-for="(name,index) in scope.row[day].split(',data:image/')">
                                <span v-if="name.length<50">{{name=='1'?'✔':name=='0'?'✖':name}}</span>
                                <span v-if="name.length>50">
																	<img :src="(index==0?'':'data:image/')+name" style="transform: rotate(270deg); width: 60px;height: 60px;"
                                       @click="showImg2((index==0?'':'data:image/')+name)" />
																</span>
                              </p>
                            </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div class="tabBbox" style="height: 100%" v-else>
                      <div class="buttonBox" style="width: 100%; ">
                        <div class="chooseButton searchButton" @click="riskExcel">{{$t('btn_51')}}</div>
                      </div>
                      <el-table :empty-text="$t('label_357')" ref="singleTable" :data="feng4Data" highlight-current-row :span-method="objectSpanMethod" border
                                style="width: 100%;margin: 10px 0" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
                        <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex0" width="50">
                        </el-table-column>
                        <el-table-column prop="item" :label="$t('label_695')" header-align="center" align="left" width="400">
                        </el-table-column>
                        <el-table-column v-for="(day,index) in feng4Date" :key="index" :label="getLable(index)" align="center"
                                         :width="150">
                          <!-- <el-table-column :prop="day" :label="day.substring(0,16)" width="120" align="center" :width="150">
														<template slot-scope="scope">
															<p v-for="name in scope.row[day].split(',')">{{name=='1'?'✔':name=='0'?'✖':name}}</p>
														</template>
												    </el-table-column> -->
                          <el-table-column :prop="day" :label="day.substring(0,16)" width="120" align="center">
                            <template slot-scope="scope">
                              <p v-for="(name,index) in scope.row[day].split(',data:image/')">
                                <span v-if="name.length<50">{{name=='1'?'✔':name=='0'?'✖':name}}</span>
                                <span v-if="name.length>50">
																	<img :src="(index==0?'':'data:image/')+name" style="transform: rotate(270deg); width: 60px;height: 60px;"
                                       @click="showImg2((index==0?'':'data:image/')+name)" />
																</span>
                              </p>
                            </template>
                          </el-table-column>
                        </el-table-column>
                      </el-table>
                    </div>

                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
              <el-tab-pane :label="$t('label_608')" name="receive">
                <div>
                  <div class="tableMes2">
                    <div class="tableMes2Box abc" style="width: 100%;">
                      <p style="margin-left: 10px; width: 170px;">{{$t('label_612')}}</p>
                      <div style="margin: 0px 20px 0px 5px;width:100%;height: 110px;border: 1px solid black;overflow:auto;">
                        <div style="margin-left: 10px;">
                          <p style="display: inline-block;">{{$t('label_616')}}: </p>
                          <el-checkbox-group v-model="tableDataEdit.productTrackList" style="display: inline-block;">
                            <el-checkbox v-for="item in productTrackList" :label="item.val" :key="item.val" :disabled="lookFlag==99">
                            </el-checkbox>
                          </el-checkbox-group>
                          <el-checkbox :label="$t('label_380')" v-model="tableDataEdit.other2" style="margin-left: 10px;" :disabled="lookFlag==99">{{$t('label_380')}}
                            <el-input class="otherInput" v-model="tableDataEdit.otherInput2" :disabled="tableDataEdit.other2?false:true"></el-input>
                          </el-checkbox>
                        </div>
                        <div style="margin-left: 10px;">
                          <p style="display: inline-block;">{{$t('label_620')}}: </p>
                          <el-checkbox-group v-model="tableDataEdit.bulkTrackList" style="display: inline-block;">
                            <el-checkbox v-for="item in bulkTrackList" :label="item.val" :key="item.val" :disabled="lookFlag==99"></el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <p style="margin-left: 10px;">{{$t('label_624')}}: <el-input class="otherInput" v-model="tableDataEdit.importants" style="width: 100px;"></el-input>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="tableMes2" v-if="lookFlag!=99">
                    <div style="margin: auto;">
											<span slot="footer" class="dialog-footer" style="display: flex;">
												<div v-loading="saveLoading" style="margin-right: 20px;" class="chooseButton sendButton" v-if="lookFlag > 0" @click="save1">{{$t('btn_13')}}</div>
											</span>
                    </div>
                  </div>
                  <div class="tableMes2" v-if="this.allList.needAccepter == '1'">
                    <div class="tableMes2Box" style="width: 100%;">
                      <p style="margin-top: 5px; width: 120px;margin-left: 10px;">{{$t('label_628')}}</p>
                      <div style="margin: 0px 20px 0px 5px;width:100%;">
                        <el-input v-model="receiveList.idea" type="textarea" :rows="2">
                        </el-input>
                      </div>
                    </div>
                  </div>
                  <div class="tableMes2" v-if="this.allList.needAccepter == '1'">
                    <div class="tableMes2Box" style="width: 100%;">
                      <p style="margin-top: 5px; width: 120px;margin-left: 10px;">{{$t('label_632')}}</p>
                      <div style="margin: 0px 20px 0px 5px;width:100%;">
                        <el-input v-model="receiveList.accord" type="textarea" :rows="2">
                        </el-input>
                      </div>
                    </div>
                  </div>
                  <div style="margin-left: 450px; width: 650px; height: 130px;margin-top: 10px;display: flex;">
                    <div class="querendiv3" v-if="this.allList.needAccepter == '1'">
                      <div class="querendiv">
                        {{$t('label_636')}}</div>
                      <div class="querendiv2" :class="{'querendiv4':(allList.autograph6 != null)}" @click="receive1(6)">
                        <span v-if="allList.autograph6 == null">{{$t('label_314')}}</span>
                        <span v-if="allList.autograph6 != null && allList.autograph6.length < 50">{{allList.autograph6}}</span>
                        <img v-if="allList.autograph6 != null && allList.autograph6.length > 50" :src="allList.autograph6" width="30%"
                             height="80%" style="transform: rotate(270deg);">
                      </div>
                    </div>
                    <div class="querendiv3">
                      <div class="querendiv">
                        {{$t('label_640')}}</div>
                      <div class="querendiv2" :class="{'querendiv4':(allList.autograph7 != null)}" @click="receive1(7)">
                        <span v-if="allList.autograph7 == null">{{$t('label_314')}}</span>
                        <span v-if="allList.autograph7 != null && allList.autograph7.length < 50">{{allList.autograph7}}</span>
                        <img v-if="allList.autograph7 != null && allList.autograph7.length > 50" :src="allList.autograph7" width="30%"
                             height="80%" style="transform: rotate(270deg);">
                      </div>
                    </div>
                    <!-- <div class="querendiv3">
											<div class="querendiv">
												报修人</div>
											<div class="querendiv2" @click="receive(8)">
												{{allList.autograph7 != null ? allList.autograph7 : '待验收'}}
											</div>
										</div> -->
                    <div class="querendiv3">
                      <div class="querendiv">
                        {{$t('label_644')}}</div>
                      <div class="querendiv2" :class="{'querendiv4':(allList.autograph8 != null)}" @click="receive1(8)">
                        <span v-if="allList.autograph8 == null">{{$t('label_314')}}</span>
                        <span v-if="allList.autograph8 != null && allList.autograph8.length < 50">{{allList.autograph8}}</span>
                        <img v-if="allList.autograph8 != null && allList.autograph8.length > 50" :src="allList.autograph8" width="30%"
                             height="80%" style="transform: rotate(270deg);">
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-loading="saveLoading" :title="$t('btn_14')" :visible.sync="unInsertVisible" append-to-body :close-on-click-modal='false' width="1000px" top="6%"
               :before-close="handleCloseInsert" custom-class="dialogBox">
      <div class="dialogBoxMes" style="padding:0 20px;">
        <div class="dialogMes">
          <p>{{$t('label_429')}}</p>
          <div class="mesInput" style="width: 680px">
            <el-autocomplete style="width:100%" v-model="knowledgeListInsert.typeName" :fetch-suggestions="querySearchAsync3"
                             :placeholder="$t('input_55')" :trigger-on-focus="false" @select="handleSelect5" value-key="name"><i slot="suffix"
                                                                                                                                 class="el-input__icon el-icon-search"></i>
            </el-autocomplete>
          </div>
        </div>
        <div class="dialogMes">
          <div class="dialogMes">
            <p><span style="color: #ff0000">*</span>{{$t('label_348')}}</p>
            <div class="mesInput" style="width: 600px;">
              <el-radio-group v-model="knowledgeListInsert.faultPhenomenon">
                <div v-for="item in faultPhenomenonList" style="display: inline-flex;width: 140px;">
                  <el-radio :label="item.val">{{item.val}}</el-radio>
                </div>
                <div style="display: inline-flex;width: 100px;">
                  <el-radio :label="$t('label_380')">
                    <el-input class="otherInput" v-model="knowledgeListInsert.fault" :disabled="knowledgeListInsert.faultPhenomenon == $t('label_380')?false:true"></el-input>
                  </el-radio>
                </div>
                <!-- <div style="margin-left: 10px;" @click="dialogFaultResult=false"><i class="el-icon-question"></i></div> -->
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="dialogMes">
          <p>{{$t('label_382')}}</p>
          <div class="mesInput" style="width: 680px">
            <el-input type="textarea" :placeholder="$t('input_46')" v-model="knowledgeListInsert.faultExplain"></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <p><span style="color: #ff0000">*</span>{{$t('label_389')}}</p>
          <div class="mesInput" style="width: 680px">
            <el-select v-model="knowledgeListInsert.faultReasonClassify" @change="getNameList2" filterable :placeholder="$t('input_65')">
              <el-option v-for="item in faultReasonClassifyList" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
            <el-select v-model="knowledgeListInsert.faultReason" filterable :placeholder="$t('input_65')">
              <el-option v-for="item in faultReasonList" :key="item.val" :label="item.val" :value="item.val">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="dialogMes">
          <div class="dialogMes">
            <p>{{$t('label_648')}}</p>
            <div class="selectMes" style="width: 320px;border:1px solid #dedede;height: 320px;overflow:auto;">
              <div class="mesInput" style="width: 100%;">
                <el-input type="textarea" :placeholder="$t('input_46')" rows="8" v-model="knowledgeListInsert.solution"></el-input>
              </div>
              <p>{{$t('label_650')}}</p>
              <el-checkbox-group v-model="knowledgeListInsert.checkList3" @change="setMealSelect" style="margin-left: 10px;">
                <el-checkbox label="0">{{$t('label_838')}}</el-checkbox>
                <el-checkbox label="1">{{$t('label_839')}}</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group v-model="knowledgeListInsert.checkList1" style="margin-left: 10px;">
                <el-checkbox v-for="check in checkList2" :label="check.key" :key="check.key" :disabled="knowledgeListInsert.checkList3[0]=='0'?false:true">{{check.val}}</el-checkbox>
              </el-checkbox-group>
              <el-checkbox :label="$t('label_380')" v-model="knowledgeListInsert.other" style="margin-left: 10px;" :disabled="knowledgeListInsert.checkList3[0]=='0'?false:true">{{$t('label_380')}}
                <el-input class="otherInput" v-model="knowledgeListInsert.otherInput" :disabled="knowledgeListInsert.other?false:true"></el-input>
              </el-checkbox>
            </div>
          </div>
          <div class="dialogMes" style="margin-left: 40px">
            <p>{{$t('label_401')}}</p>
            <div class="selectMes" style="width: 320px;border:1px solid #dedede;height: 319px;overflow:auto;">
              <div style="margin: 17px 10px;">
                <el-checkbox-group v-model="knowledgeListInsert.checkList2">
                  <el-checkbox v-for="check in checkList3" :label="check.key" :key="check.key">{{check.val}}
                  </el-checkbox>
                </el-checkbox-group>
                <el-checkbox :label="$t('label_380')" v-model="knowledgeListInsert.other1">{{$t('label_380')}}
                  <el-input class="otherInput" v-model="knowledgeListInsert.otherInput1" :disabled="knowledgeListInsert.other1?false:true"></el-input>
                </el-checkbox>
              </div>
              <div class="mesInput" style="width: 100%;">
                <el-input type="textarea" :placeholder="$t('input_46')" rows="12" v-model="knowledgeListInsert.precaution">
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="unInsertSend">{{$t('btn_13')}}</div>
			</span>
    </el-dialog>
    <el-dialog :visible="showPicture || showPdf" :show-close="true" :width="'80%'" append-to-body class="dialog-div-pre-style"
               :before-close="closePreviewClick" center>
      <div v-if="showPicture" class="dialog-body-content-base-style">
        <img style="width: 100%;height: 600px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+pictureUrl">
      </div>
      <div v-if="showPdf" class="dialog-body-content-base-style">
        <iframe frameborder="0" :src="$store.getters.getPostUrl+'mes/sysFile/pdf/'+pdfUrl" width='100%' height="600px">
        </iframe>
      </div>
    </el-dialog>
    <el-dialog :visible="showPicture2" :show-close="true" :width="'80%'" append-to-body class="dialog-div-pre-style"
               :before-close="closePreviewClick" center>
      <div class="dialog-body-content-base-style">
        <img style="width: 85%;height: 600px;transform: rotate(270deg); " :src="pictureUrl2">
      </div>

    </el-dialog>
    <el-dialog :title="$t('label_696')" :visible.sync="dialogImg" append-to-body :close-on-click-modal='false' width="800px"
               :before-close="handleCloseImg" custom-class="dialogBox">
      <img :src="imgUrl" style="transform: rotate(270deg); width: 380px;height:600px; margin-left: 200px;" />
    </el-dialog>
    <el-dialog :title="$t('label_512')" :visible.sync="causedialog" append-to-body :close-on-click-modal='false' width="800px"
               :before-close="causedialogClose" custom-class="dialogBox">
      <!-- backcause -->
      <div class="mesInput" style="width: 100%;">
        <el-input type="textarea" :placeholder="$t('input_46')" rows="6" v-model="dialogCause">
        </el-input>
        <span slot="footer" class="dialog-footer">
					<div class="chooseButton sendButton" style="margin-top: 20px;" @click="backcause">{{$t('btn_64')}}</div>
				</span>
      </div>
    </el-dialog>
    <el-dialog :title="$t('label_535')" :visible.sync="riskLegislativeCouncil" append-to-body :close-on-click-modal='false' width="1500px"
               v-dialogDrag top="3%" :before-close="fengXianClose" custom-class="dialogBox" class="bbb fengxian">
      <div>
        <div class="fengxianlihuiz">
          <p style="font-size: 16px;margin-top: 8px;font-weight: bold;">{{$t('label_655')}}：</p>
        </div>
        <div class="block">
          <el-date-picker v-model="fengxianlihuiTime1" type="datetime" :placeholder="$t('input_89')" value-format="yyyy-MM-dd HH:mm:ss"
                          format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
          -
          <el-date-picker v-model="fengxianlihuiTime2" type="datetime" :placeholder="$t('input_89')" value-format="yyyy-MM-dd HH:mm:ss"
                          format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
      </div>
      <div class="fengxianlihuiz1">
        <el-checkbox-group v-model="fengxianRiskData" style="height: 73%;">
          <el-tabs type="border-card">
            <template v-for="item in fengxianriskList">
              <el-tab-pane :label="item.head">
                <div class="riskLiskBox">
                  <template v-for="checkItem in item.rkList">
                    <div class="ridk">
                      <el-checkbox :label="checkItem" border>{{checkItem.content}}</el-checkbox>
                    </div>
                  </template>
                </div>
              </el-tab-pane>
            </template>
          </el-tabs>
        </el-checkbox-group>
        <!-- v-if="quickData=='0'" -->
        <div style="margin-left: 280px;border: 1px solid #CCCCCC; width: 900px; height: 130px;margin-top: 40px;display: flex;" class="repairClass">
          <div class="querendiv3" v-if="MenuRoleList.indexOf('158')>=0">
            <div class="querendiv">{{$t('label_544')}}</div>
            <!--            <div class="querendiv" @click="fengxiansearch(1)">{{$t('label_544')}}</div>-->
            <div class="querendiv2" :class="{'querendiv4':(allList.autograph1 != null)}" @click="fenxianConfirm(1)">
              <span v-if="allList.autograph1 == null">{{$t('label_546')}}</span>
              <span v-if="allList.autograph1 != null && allList.autograph1.length < 50">{{allList.autograph1}}</span>
              <img v-if="allList.autograph1 != null && allList.autograph1.length > 50" :src="allList.autograph1" width="30%"
                   height="80%" style="transform: rotate(270deg);">
            </div>
          </div>
          <div class="querendiv3" v-if="MenuRoleList.indexOf('159')>=0">
            <div class="querendiv">
              <!--              <div class="querendiv" @click="fengxiansearch(2)">-->
              {{$t('label_548')}}</div>
            <div class="querendiv2" :class="{'querendiv4':(allList.autograph2 != null)}" @click="fenxianConfirm(2)">
              <span v-if="allList.autograph2 == null">{{$t('label_546')}}</span>
              <span v-if="allList.autograph2 != null && allList.autograph2.length < 50">{{allList.autograph2}}</span>
              <img v-if="allList.autograph2 != null && allList.autograph2.length > 50" :src="allList.autograph2" width="30%"
                   height="80%" style="transform: rotate(270deg);">
            </div>
          </div>
          <div class="querendiv3" v-if="MenuRoleList.indexOf('160')>=0">
            <div class="querendiv">
              <!--              <div class="querendiv" @click="fengxiansearch(3)">-->
              {{$t('label_551')}}</div>
            <div class="querendiv2" :class="{'querendiv4':(allList.autograph3 != null)}" @click="fenxianConfirm(3)">
              <span v-if="allList.autograph3 == null">{{$t('label_546')}}</span>
              <span v-if="allList.autograph3 != null && allList.autograph3.length < 50">{{allList.autograph3}}</span>
              <img v-if="allList.autograph3 != null && allList.autograph3.length > 50" :src="allList.autograph3" width="30%"
                   height="80%" style="transform: rotate(270deg);">
            </div>
          </div>
          <div class="querendiv3" v-if="MenuRoleList.indexOf('161')>=0">
            <div class="querendiv">
              <!--              <div class="querendiv" @click="fengxiansearch(4)">-->
              {{$t('label_553')}}</div>
            <div class="querendiv2" :class="{'querendiv4':(allList.autograph4 != null)}" @click="fenxianConfirm(4)">
              <span v-if="allList.autograph4 == null">{{$t('label_546')}}</span>
              <span v-if="allList.autograph4 != null && allList.autograph4.length < 50">{{allList.autograph4}}</span>
              <img v-if="allList.autograph4 != null && allList.autograph4.length > 50" :src="allList.autograph4" width="30%"
                   height="80%" style="transform: rotate(270deg);">
            </div>
          </div>
          <div class="querendiv3" v-if="MenuRoleList.indexOf('421')>=0">
            <div class="querendiv">
              {{$t('label_594')}}</div>
            <div class="querendiv2" :class="{'querendiv4':(allList.autograph5 != null)}" @click="fenxianConfirm(5)">
              <span v-if="allList.autograph5 == null">{{$t('label_546')}}</span>
              <span v-if="allList.autograph5 != null && allList.autograph5.length < 50">{{allList.autograph5}}</span>
              <img v-if="allList.autograph5 != null && allList.autograph5.length > 50" :src="allList.autograph5" width="30%"
                   height="80%" style="transform: rotate(270deg);">
            </div>
          </div>
          <div class="querendiv3" v-if="MenuRoleList.indexOf('422')>=0">
            <div class="querendiv">
              {{$t('label_556')}}</div>
            <div class="querendiv2" :class="{'querendiv4':(allList.autograph9 != null)}" @click="fenxianConfirm(9)">
              <span v-if="allList.autograph9 == null">{{$t('label_546')}}</span>
              <span v-if="allList.autograph9 != null && allList.autograph9.length < 50">{{allList.autograph9}}</span>
              <img v-if="allList.autograph9 != null && allList.autograph9.length > 50" :src="allList.autograph9" width="30%"
                   height="80%" style="transform: rotate(270deg);">
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/css/map/map.css";
import "@/assets/css/common/spot.css";
import Page from "@/components/common/page";
import file from "@/assets/js/file/file.js";
import Malfunction from "@/assets/js/malfunction/malfunction.js";
import utils from '@/utils/utils';
import tree from "@/components/list/tree/maintainTree";
import calendar from "@/components/list/calendar/calendar";
import partInfo from "@/components/list/repair/partInfo";
import knowledge from "@/assets/js/knowledge/knowledge.js";

export default {
  name: 'spotResumePage',
  components: {
    Page,
    calendar,
    tree,
    partInfo
  },
  data() {
    return {
      saveLoading: false,
      showNameList: [],
      fengxianRiskData: [],
      fengxianriskList: [],
      manufacturerList: [], // 新增厂家列表
      outsourcingList: [],  // 新增外协列表
      mainFengXian: '',
      fengxianoptions: [],
      fengxianlihuiTime1: '',
      fengxianlihuiTime2: '',
      valueOpenClose: false,
      riskLegislativeCouncil: false,
      selectValue: '',
      options: [],
      selectValue3: '',
      options3: [],
      loading: false,
      selectValue2: [],
      options2: [],
      levelList: [],
      showPicture: false,
      showPicture2: false,
      pictureUrl: '',
      pictureUrl2: '',
      fengModelHead: '',
      riskID: '0',
      riskIDJHR: '0',
      riskIDBZ: '0',
      riskIDCX: '0',
      checkList2: [],
      checkList3: [],
      faultReasonList: [],
      faultReasonClassifyList: [],
      unInsertVisible: false,
      knowledgeListInsert: {
        id: '',
        faultPhenomenon: '',
        faultExplain: '',
        faultReason: '',
        solution: '',
        precaution: '',
        frequency: '',
        equipmentTypeId: '',
        faultReasonClassify: '',
        checkList1: [],
        checkList2: [],
        checkList3: [],
        other: '',
        otherInput: '',
        other1: '',
        otherInput1: '',
        impact: '',
        impactKey: '',
        impactVal: '',
        precautionKey: '',
        precautionVal: '',
        fault: '',
        typeName: ''
      },
      checkList100: [],
      knowledgeList: [],
      status: {
        active: 0,
        reportPerson: '',
        reportTime: '',
        dispatcher: '',
        dispatchTime: '',
        receivingPerson: '',
        orderTime: '',
        repairman: '',
        repairBeginTime: '',
        accepter: '',
        acceptBeginTime: '',
        acceptEndTime: '',
      },
      stepsSimple: false,
      pageNum: 1,
      select: 0,
      pageSize: 10,
      pageCount: 0,
      Readytime: '',
      getTreeMes: '1',
      fileList: [],
      treeShow: true,
      checked: false,
      dialogDeviceResult: false,
      dialogSpotResult: false,
      dialogSpotTimeEdit: false,
      dialogSpotBatchTimeEdit: false,
      dialogLogin: false,
      dialogLogin1: false,
      dialogLoginF: false,
      value: '',
      treeData: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: '2'
      },
      treeData2: {
        dataDevice: [],
        searchShow: true,
        statusShow: false,
        statusListShow: true,
        cardShow: true,
        dataAll: true,
        funtoGetMes: '3'
      },
      selectDataList: {
        name: '',
        type: '',
        id: '',
        reportPerson: '',
        beginTime: '',
        endTime: '',
        urgentLevel: [],
        urgentLevel1: [],
        status: []
      },
      faultList: [],
      urgentList: [],
      riskConfrimData: [],
      quickData: '0',
      mainEditList: {
        equipmentId: '',
        faultPhenomenon: '',
        fault: '',
        devicName: '',
        reportPerson: '',
        mobile: '',
        urgentLevel: '',
        faultSource: '',
        stop: '1',
        expectTime: '',
        reportTime: '',
        stopTime: '',
        faultExplain: '',
        faultImg: '',
        status: '1',
        superior: '',
        repairImg: [],
        deptId: '',
        distinction: '0'
      },
      checkMesList: [{
        value: ''
      }],
      checkList: [],
      faultPhenomenonList: [],
      urgentLevelStatusList: [{
        text: '无',
        color: '#FFFFFF'
      }, {
        text: '一般',
        color: '#aeaeae'
      }, {
        text: '紧急',
        color: '#e60000'
      }],
      stopStatusList: [{
        text: this.$t('btn_36'),
        color: '#3fb393'
      }, {
        text: this.$t('btn_37'),
        color: '#e60000'
      }],
      spotStatusNumList: [{
        text: this.$t('label_272'),
        type: '0',
        check: false,
        num: '0',
        color: '#000000'
      }, {
        text: this.$t('label_299'),
        type: '1',
        check: true,
        num: '0',
        color: '#e60000'
      }, {
        text: this.$t('label_303'),
        type: '2',
        check: true,
        num: '0',
        color: '#e60000'
      }, {
        text: this.$t('label_307'),
        type: '3',
        check: true,
        num: '0',
        color: '#e60000'
      }, {
        text: this.$t('label_311'),
        type: '4',
        check: true,
        num: '0',
        color: '#ffb400'
      }, {
        text: this.$t('label_314'),
        type: '5',
        check: true,
        num: '0',
        color: '#e60000'
      }, {
        text: this.$t('label_318'),
        type: '6',
        check: true,
        num: '0',
        color: '#ffb400'
      }, {
        text: this.$t('label_829'),
        type: '7',
        check: true,
        num: '0',
        color: '#3fb393'
      }, {
        text: this.$t('label_326'),
        type: '8',
        check: true,
        num: '0',
        color: '#aeaeae'
      }],
      tableDataTree: [],
      tableDataTreeTime: [],
      activeNameTree: 'second',
      activeNameSpot: 'spot',
      mainEditTree: '',
      fengXianLiHuiTree: 'project',
      activeNameDevice: 'device',
      mainConfrimTree: 'main',
      tableDataEdit: {
        id: '',
        risk: [],
        repairMode: [],
        faultLevel: '',
        remarks: '',
        repairman: [],
        repairmanId: '',
        accepter: '',
        accepterId: '',
        participants: '',
        participantsId: '',
        needAccepter: 0,
        needAccuracy: 0,
        importants: '',
        delayedDay: '',
        other: '',
        other1: '',
        otherInput: '',
        other2: '',
        otherInput2: '',
        delayedReason: '',
        reason: [],
        productTrackList: [],
        bulkTrackList: [],
        manufacturer: '',  // 存储选中的厂家ID
        outsourcing: ''  // 存储选中的外协ID
      },
      productTrackList: [],
      bulkTrackList: [],
      malfunctionList: [],
      maintainList: [],
      dictList1: [],
      dictList2: [],
      riskList: [],
      riskConfrimList: [],
      allList: {},
      deviceName: '',
      receiveList: {
        idea: '',
        accord: '',
        userName: '',
        passWord: '',
        autograph: '',
        confirm: '',
        taskId: '',
        riskIdList: [],
        id: '',
        flag: "0",
        distinction: ''
      },
      knowledgeCheckList: [],
      knowledgeListNew: [],
      knowledgeList2: [],
      cause: [],
      causeList: [],
      delayedList: [],
      knowledgeSelect: {
        faultReasonClassify: '',
        faultReason: '',
        faultExplain: '',
      },
      knowledgeSelect2: {
        faultReasonClassify: '',
        faultReason: '',
        faultExplain: '',
      },
      commitList: {
        id: '',
        remark: '',
        type: '',
        status: '',
        delayed: '',
        delayedReason: '',
        needAccepter: '',
        needAccuracy: '',
        importants: '',
        repairImg: [],
        equipmentRepairSolutionList: [],
        equipmentUsePartList: [],
        delayedDay: '',
        productTrackKey: '',
        productTrackVal: '',
        bulkTrackKey: '',
        bulkTrackVal: '',
        risk: '',
        repairMode: ''
      },
      id: '',
      equipmentId: '',
      mainEditSheet: 'feng1',
      feng4Data: [],
      feng4Date: [],
      feng4Date1: [],
      feng4Data1: [],
      feng4Date2: [],
      feng4Data2: [],
      feng4Date3: [],
      feng4Data3: [],
      feng4Date4: [],
      feng4Data4: [],
      lookFlag: 4,
      dialogImg: false,
      imgUrl: '',
      fengxianConfirmData: {
        taskId: '',
        riskIdList: [],
        confirm: '',
        userName: '',
        passWord: '',
        autograph: '',
        repairPlanBeginTime: '',
        repairPlanEndTime: '',
      },
      saveStatus: 1,
      saveStatus2: 1,
      showPdf: false,
      pdfUrl: '',
      showIconList: {},
      deviceList: [],
      showLiHui: false,
      causedialog: false,
      dialogCause: '',
      width: '340px',
      qrCodeShow: false,
      MenuRoleList: [],
      manufacturerRepairKeywords: ['厂家维修', 'メーカー修理'],
      outsourcingRepairKeywords: ['外协维修', '外注修理']
    }
  },
  computed: {
    // 新增：判断是否选择了任意语言的“厂家维修”
    isManufacturerRepair() {
      // 检查 repairMode 数组是否包含关键词数组中的任意一项
      return this.manufacturerRepairKeywords.some(keyword => {
        return this.tableDataEdit.repairMode.includes(keyword);
      });
    },
    isOutsourcingRepair() {
      // 检查 repairMode 数组是否包含关键词数组中的任意一项
      return this.outsourcingRepairKeywords.some(keyword => {
        return this.tableDataEdit.repairMode.includes(keyword);
      });
    },
    // 其他已有的计算属性...（如果有的话）
  },
  methods: {
    // 获取厂家列表
    getManufacturerList() {
      // 假设你有一个 API 接口来获取厂家数据
      file.getManufacturerList().then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.manufacturerList = data.data;
        }
      }).catch((response) => {
        console.log(response);
      });
    },
    // 获取外协列表
    getOutsourcingList() {
      // 假设你有一个 API 接口来获取外协数据
      file.getOutsourcingList().then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.outsourcingList = data.data;
        }
      }).catch((response) => {
        console.log(response);
      });
    },
    previewPdf(row) {
      file.selectFileType(row).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          let type = data.data;
          if (type.indexOf(".pdf") != -1) {
            this.pdfUrl = row;
            this.showPdf = true
          } else if (type.indexOf(".jpg") != -1 || type.indexOf(".png") != -1 || type.indexOf(".jpeg") != -1) {
            this.pictureUrl = row;
            this.showPicture = true
          } else {
            this.$message(this.$t('msg_9'))
          }
        } else {
          this.$message(this.$t('msg_10'))
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    showName(row) {
      file.selectFileName(row).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.showNameList[row] = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      return this.showNameList[row]
    },
    showIcon(row) {
      file.selectFileType(row).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          let type = data.data;
          if (type.indexOf(".jpg") != -1 || type.indexOf(".png") != -1 || type.indexOf(".jpeg") != -1 || type.indexOf(
            ".gif") != -1) {
            this.showIconList[row] = true;
          } else {
            this.showIconList[row] = false;
          }
        }
      }).catch((response) => {
        console.log(response)
      })
      return this.showIconList[row]
    },
    fengTime() {
      let param = {
        id: this.id,
        repairPlanBeginTime: this.fengxianlihuiTime1,
        repairPlanEndTime: this.fengxianlihuiTime2
      }
      Malfunction.updateTime(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.$message({
            message: this.$t('msg_23'),
            type: 'success'
          });
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    handleCloseImg() {
      this.dialogImg = false;
    },
    // 关闭弹出框
    fengXianClose() {
      this.riskLegislativeCouncil = false;
    },
    stopChange(val) {
      if (val == 0) {
        this.mainEditList.stopTime = "";
      }
    },
    riskExcel() {
      if (this.allList.appointMeet == 1) {
        window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentRepairRecord/excel1/' + this.id;
      } else {
        window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentRepairRecord/excel/' + this.id;
      }

    },
    showLevel(key) {
      for (let i = 0; i < this.urgentLevelStatusList.length; i++) {
        if (this.urgentLevelStatusList[i].key == key) {
          return this.urgentLevelStatusList[i].val;
        }
      }
    },
    handleClick0(tab, event) {
      if (tab.name == 'feng4') {
        let that = this;
        utils.clearTime();
        this.riskRecord();
        utils.timing(function() {
          that.riskRecord()
        }, 30000);
      }
    },
    riskRecord() {
      if (this.allList.appointMeet == 1) {
        file.riskRecord1(this.id).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.feng4Date1 = data.data[0].date;
            this.feng4Data1 = data.data[0].data;
            this.feng4Date2 = data.data[1].date;
            this.feng4Data2 = data.data[1].data;
            this.feng4Date3 = data.data[2].date;
            this.feng4Data3 = data.data[2].data;
            this.feng4Date4 = data.data[3].date;
            this.feng4Data4 = data.data[3].data;
          }
        }).catch((response) => {
          console.log(response)
        })
      } else {
        file.riskRecord(this.id).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.feng4Date = data.data.date;
            this.feng4Data = data.data.data;
          }
        }).catch((response) => {
          console.log(response)
        })
      }
    },
    getLable(index) {
      if (index == 0) {
        return this.$t('label_33') + "（1" + this.$t('label_37') + "）";
      }
      return index + 1 + this.$t('label_37');
    },
    getLable1(index) {
      if (index == 0) {
        return this.$t('label_33');
      }
      return index + this.$t('label_37');
    },
    objectSpanMethod({
                       row,
                       column,
                       rowIndex,
                       columnIndex
                     }) {
      if (rowIndex + 1 == this.feng4Data.length && columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 2
        }
      } else if (rowIndex + 1 == this.feng4Data.length && (columnIndex < 2)) { //重点在else
        return {
          rowspan: 0, //清除就是这俩属性设置为0
          colspan: 0 //清除就是这俩属性设置为0
        }
      }
    },
    objectSpanMethod1({
                        row,
                        column,
                        rowIndex,
                        columnIndex
                      }) {
      if (rowIndex + 1 == this.feng4Data1.length && columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 2
        }
      } else if (rowIndex + 1 == this.feng4Data1.length && (columnIndex < 2)) { //重点在else
        return {
          rowspan: 0, //清除就是这俩属性设置为0
          colspan: 0 //清除就是这俩属性设置为0
        }
      }
    },
    objectSpanMethod2({
                        row,
                        column,
                        rowIndex,
                        columnIndex
                      }) {
      if (rowIndex + 1 == this.feng4Data2.length && columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 2
        }
      } else if (rowIndex + 1 == this.feng4Data2.length && (columnIndex < 2)) { //重点在else
        return {
          rowspan: 0, //清除就是这俩属性设置为0
          colspan: 0 //清除就是这俩属性设置为0
        }
      }
    },
    objectSpanMethod3({
                        row,
                        column,
                        rowIndex,
                        columnIndex
                      }) {
      if (rowIndex + 1 == this.feng4Data3.length && columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 2
        }
      } else if (rowIndex + 1 == this.feng4Data3.length && (columnIndex < 2)) { //重点在else
        return {
          rowspan: 0, //清除就是这俩属性设置为0
          colspan: 0 //清除就是这俩属性设置为0
        }
      }
    },
    objectSpanMethod4({
                        row,
                        column,
                        rowIndex,
                        columnIndex
                      }) {
      if (rowIndex + 1 == this.feng4Data4.length && columnIndex == 0) {
        return {
          rowspan: 1,
          colspan: 2
        }
      } else if (rowIndex + 1 == this.feng4Data4.length && (columnIndex < 2)) { //重点在else
        return {
          rowspan: 0, //清除就是这俩属性设置为0
          colspan: 0 //清除就是这俩属性设置为0
        }
      }
    },
    remoteMethod(query) {
      // if (query !== '') {
      this.loading = true;
      file.repairTaskNum(query).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.loading = false;
          this.options = data.data;
        }
      }).catch((response) => {
        this.loading = false;
        console.log(response)
      })
      // } else {
      // 	this.options = [];
      // }
    },
    remoteMethod3(query) {

      // if (query !== '') {
      this.loading = true;
      file.selectUser(query).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.loading = false;
          this.options3 = data.data;
        }
      }).catch((response) => {
        this.loading = false;
        console.log(response)
      })
      // } else {
      // 	this.options3 = [];
      // }
    },
    remoteMethod2(query) {
      // if (query !== '') {
      this.loading = true;
      file.selectUser(query).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.loading = false;
          this.options2 = data.data;
        }
      }).catch((response) => {
        this.loading = false;
        console.log(response)
      })
      // } else {
      // 	this.options2 = [];
      // }
    },

    closePreviewClick() {
      this.showPicture = false
      this.showPdf = false
      this.showPicture2 = false
    },
    showImg(url) {
      this.pictureUrl = url;
      this.showPicture = true;
    },
    showImg2(url) {
      this.pictureUrl2 = url;
      this.showPicture2 = true;
    },
    unInsertSend() {
      // Validate required fields first
      if (this.knowledgeListInsert.faultPhenomenon == '' || this.knowledgeListInsert.faultPhenomenon == null) {
        this.$message({
          message: this.$t('input_67'),
          type: 'error'  // Changed from 'success' to 'error' for validation messages
        });
        return;
      }

      if (this.knowledgeListInsert.faultReasonClassify == '' || this.knowledgeListInsert.faultReason == '') {
        this.$message({
          message: this.$t('input_68'),
          type: 'error'  // Changed from 'success' to 'error'
        });
        return;
      }

      this.saveLoading = true;

      // Process the data
      if (this.knowledgeListInsert.faultPhenomenon == this.$t('label_380')) {
        this.knowledgeListInsert.faultPhenomenon = this.knowledgeListInsert.fault;
      }

      this.knowledgeListInsert.impact = this.knowledgeListInsert.checkList3[0];

      // Process impact keys and values
      this.knowledgeListInsert.impactKey = '';
      this.knowledgeListInsert.impactVal = '';
      for (let key in this.knowledgeListInsert.checkList1) {
        this.knowledgeListInsert.impactKey += this.checkList2[key].key + ",";
        this.knowledgeListInsert.impactVal += this.checkList2[key].val + ",";
      }

      if (this.knowledgeListInsert.other) {
        this.knowledgeListInsert.impactKey += "0";
        this.knowledgeListInsert.impactVal += this.knowledgeListInsert.otherInput;
      } else {
        this.knowledgeListInsert.impactKey = this.knowledgeListInsert.impactKey.substring(0, this.knowledgeListInsert.impactKey.length - 1);
        this.knowledgeListInsert.impactVal = this.knowledgeListInsert.impactVal.substring(0, this.knowledgeListInsert.impactVal.length - 1);
      }

      // Process precaution keys and values
      this.knowledgeListInsert.precautionKey = '';
      this.knowledgeListInsert.precautionVal = '';
      for (let key in this.knowledgeListInsert.checkList2) {
        this.knowledgeListInsert.precautionKey += this.checkList3[key].key + ",";
        this.knowledgeListInsert.precautionVal += this.checkList3[key].val + ",";
      }

      if (this.knowledgeListInsert.other1) {
        this.knowledgeListInsert.precautionKey += "0";
        this.knowledgeListInsert.precautionVal += this.knowledgeListInsert.otherInput1;
      } else {
        this.knowledgeListInsert.precautionKey = this.knowledgeListInsert.precautionKey.substring(0, this.knowledgeListInsert.precautionKey.length - 1);
        this.knowledgeListInsert.precautionVal = this.knowledgeListInsert.precautionVal.substring(0, this.knowledgeListInsert.precautionVal.length - 1);
      }

      // Submit the data
      knowledge.insert(this.knowledgeListInsert).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.knowledgeListNew.push(data.data);
          this.selectknowledge();
          this.unInsertVisible = false;
        }
        this.saveLoading = false;
      }).catch((response) => {
        console.log(response);
        this.saveLoading = false;
      });
    },
    setMealSelect() {
      // 截取数组的最后一位,并从新赋值
      this.knowledgeListInsert.checkList3 = this.knowledgeListInsert.checkList3.slice(-1)
    },
    setMealSelect1() {
      // 截取数组的最后一位,并从新赋值
      this.checkList100 = this.checkList100.slice(-1);
      if (this.checkList100[0] == '1') {
        this.tableDataEdit.other = true;
      } else {
        this.tableDataEdit.other = false;
      }
    },
    handleCloseInsert() {
      this.unInsertVisible = false;
    },
    removeKnowledgeListNew(index) {
      this.knowledgeListNew.splice(index, 1);
    },
    goNew() {
      for (let i = 0; i < this.knowledgeCheckList.length; i++) {
        let add = true;
        for (let j = 0; j < this.knowledgeListNew.length; j++) {
          if (this.knowledgeListNew[j].id == this.knowledgeCheckList[i].id) {
            add = false;
          }
        }
        if (add) {
          this.knowledgeListNew.push(this.knowledgeCheckList[i])
          for (let j = 0; j < this.knowledgeListNew.length; j++) {
            this.knowledgeListNew.knowId = this.knowledgeCheckList[i].id;
          }
        }
      }
      this.knowledgeCheckList = [];
    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    getIndex0(index) {
      if ((this.pageNum - 1) * this.pageSize + index + 1 == this.feng4Data.length) {
        return this.$t('label_40')
      }
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    getIndex1(index) {
      if ((this.pageNum - 1) * this.pageSize + index + 1 == this.feng4Data1.length) {
        return this.$t('label_44')
      }
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    getIndex2(index) {
      if ((this.pageNum - 1) * this.pageSize + index + 1 == this.feng4Data2.length) {
        return this.$t('label_49')
      }
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    getIndex3(index) {
      if ((this.pageNum - 1) * this.pageSize + index + 1 == this.feng4Data3.length) {
        return this.$t('label_53')
      }
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    getIndex4(index) {
      if ((this.pageNum - 1) * this.pageSize + index + 1 == this.feng4Data4.length) {
        return this.$t('label_57')
      }
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    selectProp: function(index) {
      this.select = index
    },
    handleClose() {
      if (this.lookFlag != 99) {

        if (this.allList.distinction <2&&this.allList.distinction >0&&this.allList.confirm != '99' && (this.allList.status == '3' || this.allList.status == '4')) {
          this.$confirm(this.$t('msg_67'), this.$t('label_358'), {
            confirmButtonText: this.$t('label_100'),
            cancelButtonText: this.$t('btn_1'),
            type: 'warning'
          }).then(() => {
            this.dialogDeviceSpot = false;
            this.dialogSpotResult = false;
            this.dialogSpotBatchTimeEdit = false;
            this.mainEditSheet = 'feng1';
            utils.clearTime();
            this.deleteConfirm()
          }).catch(() => {

          });
        }else{
          this.dialogDeviceSpot = false;
          this.dialogSpotResult = false;
          this.dialogSpotBatchTimeEdit = false;
          this.mainEditSheet = 'feng1';
          utils.clearTime();
        }
      }else{
        this.dialogDeviceSpot = false;
        this.dialogSpotResult = false;
        this.dialogSpotBatchTimeEdit = false;
        this.mainEditSheet = 'feng1';
        utils.clearTime();
      }

    },
    deleteConfirm() {
      Malfunction.deleteConfirm(this.id).then((response) => {

      }).catch((response) => {
        console.log(response)
      })
    },
    handleClose1() {
      this.dialogLogin = false;
    },
    handleClose2() {
      this.dialogLogin1 = false;
    },
    handleCloseF() {
      this.dialogLoginF = false;
    },
    getRiskList() {
      this.riskConfrimList = [];
      let param = {
        taskId: this.receiveList.taskId
      }
      Malfunction.riskConfrimListMes(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.riskConfrimList = data.data;
          this.fengModelHead = this.riskConfrimList[0].head;
          // for (let key in this.riskConfrimList[0].rkList) {
          // 	this.riskConfrimData.push(this.riskConfrimList[0].rkList[key].id);
          // }
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    getRiskList2(status) {
      if (this.allList.appointMeet == 1) {
        this.saveStatus = status
        this.riskConfrimData = [];
        this.riskConfrimList = [];
        let param = {
          taskId: this.receiveList.taskId,
          status: status
        }
        Malfunction.riskDetailListAll(param).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.riskConfrimList = data.data;
            this.fengModelHead = this.riskConfrimList[0].head;
            // for (let key in this.riskConfrimList[0].rkList) {
            // 	this.riskConfrimData.push(this.riskConfrimList[0].rkList[key].id);
            // }
          } else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          }
        }).catch((response) => {
          console.log(response)
        })
      }
    },
    moveUp(item, index) {
      this.tableDataTree.splice(index - 1, 0, item); // 定位到点击位置的上一行，0即不删除如何元素，在此位置插入item
      this.tableDataTree.splice(index + 1, 1); // 此时数组中有重复元素，把原来被挤下去的元素删除
    },
    // 下移
    moveDown(item, index) {
      this.tableDataTree.splice(index + 2, 0, item);
      this.tableDataTree.splice(index, 1);
    },
    moveUpDevice(item, index) {
      this.allDeviceData.splice(index - 1, 0, item); // 定位到点击位置的上一行，0即不删除如何元素，在此位置插入item
      this.allDeviceData.splice(index + 1, 1); // 此时数组中有重复元素，把原来被挤下去的元素删除
    },
    // 下移
    moveDownDevice(item, index) {
      this.allDeviceData.splice(index + 2, 0, item);
      this.allDeviceData.splice(index, 1);
    },
    // 控制下移按钮的显示于隐藏
    getFormLength(index) {
      if (index === this.tableDataTree.length - 1) return true;
      else return false;
    },
    getFormLengthDevice(index) {
      if (index === this.allDeviceData.length - 1) return true;
      else return false;
    },
    handleCurrentChangeAll(info) {},
    handleCurrentChangeDevice(info) {},
    handleCurrentChangeTree(info) {
      this.tableDataTreeInfo = info;
    },
    tableDataTreeInfoEdit() {
      if (Object.keys(this.tableDataTreeInfo).length > 0) {
        this.dialogDeviceSpot = true;
        this.tableDataTreeEdit = this.tableDataTreeInfo
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    login() {
      if (this.receiveList.userName == '') {
        utils.messageAlert(this.$t('input_66'), this.$t('label_717'), this.$t('label_100'));
        return;
      }
      if (this.receiveList.passWord == '') {
        utils.messageAlert(this.$t('input_28'), this.$t('label_717'), this.$t('label_100'));
        return;
      }
      if (this.allList.distinction < 2) {
        let num = 0;
        for (let key in this.riskConfrimList) {
          num = num + this.riskConfrimList[key].rkList.length;
        }
        if (num != this.riskConfrimData.length) {
          utils.messageAlert(this.$t('input_69'), this.$t('label_717'), this.$t('label_100'));
          return;
        }
        if (this.allList.appointMeet == 1) {
          if (this.saveStatus != this.saveStatus2) {
            utils.messageAlert(this.$t('msg_68'), this.$t('label_717'), this.$t('label_100'));
            return;
          }
        }
      }

      this.receiveList.riskIdList = this.riskConfrimData;
      Malfunction.webConfirm(this.receiveList).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.dialogLogin = false;
          if (this.allList.appointMeet == 1) {
            if (this.receiveList.distinction == '2' && this.receiveList.confirm == 9) {
              this.dialogSpotResult = false;
            }
          } else {
            if ((this.receiveList.distinction == '2'||this.receiveList.distinction == '0') && this.receiveList.confirm == 5) {
              this.dialogSpotResult = false;
            }
          }

          this.selectAll();
          this.search({
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          });
          this.$message({
            message: this.$t('msg_23'),
            type: 'success'
          });
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    login1() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.receiveList.userName == '') {
        loading.close();
        utils.messageAlert(this.$t('input_66'), this.$t('label_717'), this.$t('label_100'));
        return;
      }
      if (this.receiveList.passWord == '') {
        loading.close();
        utils.messageAlert(this.$t('input_28'), this.$t('label_717'), this.$t('label_100'));
        return;
      }
      // this.receiveList.taskId = this.allList.
      Malfunction.acceptance(this.receiveList).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.dialogLogin1 = false;
          this.selectAll();
          this.search({
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          });
          loading.close();
          this.$message({
            message: this.$t('label_681'),
            type: 'success'
          });
          if(data.data=='7'){
            this.dialogSpotResult = false;
          }
        } else {
          loading.close();
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        loading.close();
        console.log(response)
      })
    },
    handleCurrentChangeTreeTime(info) {
      this.showIconList = {}
      this.tableInfo = info;
      this.id = info.id;
      this.equipmentId = info.equipmentId;
      this.selectRisk(this.equipmentId);
      this.selectAll();
    },
    handleNodeClickDevice(data) {
      if (data.label == this.$t('label_272')) {
        this.getTreeMes = '1';
      } else {
        this.getTreeMes = '1';
      }
    },
    handleNodeClickArea(data) {
      if (data.label == this.$t('label_272')) {
        this.getTreeMes = '1';
      } else {
        this.getTreeMes = '1';
      }
    },
    handleClickTree(tab, event) {
      if (tab.label == this.$t('label_161')) {
        this.getTreeMes = '1';
      } else {
        this.getTreeMes = '1';
      }
    },
    handleClickSpot(tab, event) {
      console.log(tab, event);
    },
    handleClickDevice(tab, event) {
      console.log(tab, event);
    },
    getDeviceMes(data) {
      this.selectDataList.type = data.type;
      this.selectDataList.id = data.id;
      this.deviceName = data.name;
      this.search({
        pageNum: 1,
        pageSize: this.pageSize,
      });
    },

    selectRepairList(param) {
      // for (let i = 0; i < this.selectDataList.urgentLevel1.length; i++) {
      // 	if (this.selectDataList.urgentLevel1[i] == '一般') {
      // 		this.selectDataList.urgentLevel.push(1);
      // 	} else if (this.selectDataList.urgentLevel1[i] == '紧急') {
      // 		this.selectDataList.urgentLevel.push(2);
      // 	}
      // }
      this.selectDataList.urgentLevel = this.selectDataList.urgentLevel1;
      for (let i = 0; i < this.spotStatusNumList.length; i++) {
        if (this.spotStatusNumList[i].check) {
          this.selectDataList.status.push(this.spotStatusNumList[i].type);
        }
      }
      this.selectDataList.beginTime = this.Readytime[0] + " 00:00:00";
      this.selectDataList.endTime = this.Readytime[1] + " 23:59:59";
      let dataParam = this.selectDataList;
      let newParam = Object.assign(param, dataParam);
      this.searchStauts(newParam);
      Malfunction.selectEquipmentRepair(newParam).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableDataTreeTime = data.data.records;
          this.selectDataList.urgentLevel = [];
          // this.selectDataList.urgentLevel1 = [];
          this.selectDataList.status = [];
          this.pageSize = data.data.size;
          this.pageCount = data.data.total;
          this.pageNum = data.data.current;
          this.$refs['pageModel'].setCurrent(this.pageNum);
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    searchStauts(param) {
      Malfunction.getRecordStatus(param, true).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.spotStatusNumList[0].num = data.data.num0
          this.spotStatusNumList[1].num = data.data.num1
          this.spotStatusNumList[2].num = data.data.num2
          this.spotStatusNumList[3].num = data.data.num3
          this.spotStatusNumList[4].num = data.data.num4
          this.spotStatusNumList[5].num = data.data.num5
          this.spotStatusNumList[6].num = data.data.num6
          this.spotStatusNumList[7].num = data.data.num7
          this.spotStatusNumList[8].num = data.data.num8
        }
      }).catch((response) => {
        console.log(response)
      })
    },

    search(param) {
      this.selectRepairList(param);
    },
    getNowTime() {
      let zeroTime = new Date();
      let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
        1; //月份从0开始，因此要+1
      let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
      let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
      return now;
    },
    getBeforeTime() {
      let time = (new Date).getTime() - 24 * 60 * 60 * 1000;
      let zeroTime = new Date(time);
      let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
        1; //月份从0开始，因此要+1
      let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
      let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
      return now;
    },
    getThreeDaysAgo() {
      let myDate = new Date();
      let lw = new Date(myDate - 1000 * 60 * 60 * 24 * 30); //最后一个数字30可改，30天的意思
      let lastY = lw.getFullYear();
      let lastM = lw.getMonth() + 1;
      let lastD = lw.getDate();
      let startData =
        lastY +
        "-" +
        (lastM < 10 ? "0" + lastM : lastM) +
        "-" +
        (lastD < 10 ? "0" + lastD : lastD); //三十天之前日期
      return startData;
    },
    selectRisk(id) {
      let param = {
        id: id,
        type: 1
      };
      file.selectRisk(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.riskList = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    selectdictList() {
      file.getByDictIdALL({dictId: 15, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.malfunctionList = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(15).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.malfunctionList = data.data
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
      file.getByDictIdALL({dictId: 16, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.maintainList = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(16).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.maintainList = data.data
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
      file.getByDictIdALL({dictId: 9, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.cause = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(9).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.cause = data.data
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
      // file.getDictList(10).then((response) => {
      // 	const data = response.data;
      // 	if (data.code == "1") {
      // 		this.causeList = data.data
      // 	}
      // }).catch((response) => {
      // 	console.log(response)
      // })
      file.getByDictIdALL({dictId: 17, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.delayedList = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(17).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.delayedList = data.data
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
      file.getByDictIdALL({dictId: 18, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.productTrackList = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(18).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.productTrackList = data.data
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
      // file.getDictList(19).then((response) => {
      // 	const data = response.data;
      // 	if (data.code == "1") {
      // 		this.bulkTrackList = data.data
      // 	}
      // }).catch((response) => {
      // 	console.log(response)
      // })
      file.getByDictIdALL({dictId: 19, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.bulkTrackList = data.data
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    save(index) {
      //1 派单 2接单
      if (index == 1) {
        if (this.valueOpenClose) {
          if (this.tableDataEdit.risk.length <= 0) {
            utils.messageAlert(this.$t('input_70'), this.$t('label_358'), this.$t('label_100'));
            return;
          }
          if (this.allList.autograph1 == null || this.allList.autograph2 == null || this.allList.autograph3 == null || this
            .allList.autograph4 == null || this.allList.autograph5 == null) {
            utils.messageAlert(this.$t('input_71'), this.$t('label_358'), this.$t('label_100'));
            return;
          }
        }
        if (this.selectValue == '') {
          this.$message({
            message: this.$t('input_72'),
            type: 'warning'
          });
          return;
        }

        if (this.selectValue3 == '') {
          this.$message({
            message: this.$t('input_73'),
            type: 'warning'
          });
          return;
        }
        if (this.tableDataEdit.repairMode.length <= 0) {
          this.$message({
            message: this.$t('input_74'),
            type: 'warning'
          });
          return;
        }
        if (this.tableDataEdit.faultLevel == null || this.tableDataEdit.faultLevel == '') {
          this.$message({
            message: this.$t('input_75'),
            type: 'warning'
          });
          return;
        }
        if (this.selectValue2.length < 1) {
          this.$message({
            message: this.$t('msg_236'),
            type: 'warning'
          });
          return false;
        }
        this.tableDataEdit.risk = JSON.stringify(this.tableDataEdit.risk)
        this.tableDataEdit.repairMode = JSON.stringify(this.tableDataEdit.repairMode)
        let arr = this.selectValue.split("&@");
        this.tableDataEdit.repairmanId = arr[0];
        this.tableDataEdit.repairman = arr[1];
        let arr3 = this.selectValue3.split("&@");
        this.tableDataEdit.accepterId = arr3[0];
        this.tableDataEdit.accepter = arr3[1];

        // if(this.selectValue2.length == 0){
        // 	this.$message({
        // 		message: '请填写参与人',
        // 		type: 'warning'
        // 	});
        // }
        let participants = "";
        let participantsId = "";
        for (let v of this.selectValue2) {
          let arr2 = v.split("&@");
          participantsId += "," + arr2[0];
          participants += "," + arr2[1];
        }
        this.tableDataEdit.participants = participants.substring(1);
        this.tableDataEdit.participantsId = participantsId.substring(1);
        this.tableDataEdit.appointMeet = 0;
        if (this.valueOpenClose) {
          this.tableDataEdit.appointMeet = 1;
        }
        // 将选中的厂家或外协ID添加到提交数据中
        this.tableDataEdit.manufacturerName = this.tableDataEdit.manufacturer;
        this.tableDataEdit.outsourcingName = this.tableDataEdit.outsourcing;
        Malfunction.distribute(this.tableDataEdit).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.dialogSpotResult = false;
            this.search({
              pageNum: this.pageNum,
              pageSize: this.pageSize,
            });
            this.$message({
              message: this.$t('msg_25'),
              type: 'success'
            });
          }
        }).catch((response) => {
          console.log(response)
        })
      } else if (index == 2) {
        if (this.allList.repairmanId != this.$store.getters.getCurrentUser.userId
          && this.allList.participantsId.indexOf(this.$store.getters.getCurrentUser.userId) == -1) {
          utils.messageAlert(this.$t('msg_70'), this.$t('label_358'), this.$t('label_100'));
          return false;
        }
        Malfunction.orderReceiving(this.tableDataEdit.id).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.dialogSpotResult = false;
            this.search({
              pageNum: this.pageNum,
              pageSize: this.pageSize,
            });
            this.$message({
              message: this.$t('msg_26'),
              type: 'success'
            });
          }
        }).catch((response) => {
          console.log(response)
        })
      } else if (index == 3) {
        if (this.knowledgeListNew.length <= 0) {
          this.$message({
            message: this.$t('input_76'),
            type: 'warning'
          });
          return;
        }
        if (this.tableDataEdit.repairMode.length <= 0) {
          this.$message({
            message: this.$t('input_74'),
            type: 'warning'
          });
          return;
        }
        if (this.checkList100[0] == undefined) {
          this.$message({
            message: this.$t('input_77'),
            type: 'warning'
          });
          return;
        }
        this.commitList.delayedReason = "";

        if (this.checkList100[0] == '0') {
          this.commitList.delayedReason = '';
        } else {
          if (!this.isNumber(this.tableDataEdit.delayedDay)) {
            this.$message({
              message: this.$t('input_78'),
              type: 'warning'
            });
            this.tableDataEdit.risk = JSON.parse(this.tableDataEdit.risk);
            this.tableDataEdit.repairMode = JSON.parse(this.tableDataEdit.repairMode);
            return;
          } else {
            if (!((this.tableDataEdit.reason != null && this.tableDataEdit.reason != '') || this.tableDataEdit.other1)) {
              this.$message({
                message: this.$t('input_79'),
                type: 'warning'
              });
              return;
            }
            if (this.tableDataEdit.reason != null && this.tableDataEdit.reason != '') {
              for (let key in this.tableDataEdit.reason) {
                this.commitList.delayedReason += this.tableDataEdit.reason[key] + ",";
              }
            }
            if (this.tableDataEdit.other1) {
              if (this.tableDataEdit.otherInput == null || this.tableDataEdit.otherInput == '') {
                this.$message({
                  message: this.$t('input_79'),
                  type: 'warning'
                });
                return;
              }
              this.commitList.delayedReason += this.tableDataEdit.otherInput;
            }
          }
        }
        this.tableDataEdit.risk = JSON.stringify(this.tableDataEdit.risk)
        this.tableDataEdit.repairMode = JSON.stringify(this.tableDataEdit.repairMode)
        this.commitList.risk = this.tableDataEdit.risk;
        this.commitList.repairMode = this.tableDataEdit.repairMode;
        this.commitList.needAccepter = this.tableDataEdit.needAccepter;
        this.commitList.needAccuracy = this.tableDataEdit.needAccuracy;
        this.commitList.importants = this.tableDataEdit.importants;
        this.commitList.equipmentRepairSolutionList = this.knowledgeListNew;
        this.commitList.equipmentUsePartList = this.$refs.partInfoDisplay.dataList;
        this.commitList.type = '1';
        this.commitList.repairImg = this.mainEditList.repairImg.join(',');
        this.commitList.delayed = this.checkList100[0];
        this.commitList.delayedDay = this.tableDataEdit.delayedDay;

        Malfunction.saveCommit(this.commitList).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.dialogSpotResult = false;
            this.search({
              pageNum: this.pageNum,
              pageSize: this.pageSize,
            });
            this.$message({
              message: this.$t('label_707'),
              type: 'success'
            });
          }
        }).catch((response) => {
          console.log(response)
        })
      } else if (index == 4) {
        this.rapidProcessing();
      } else if (index == 5) {
        this.tableDataEdit.risk = JSON.stringify(this.tableDataEdit.risk)
        this.tableDataEdit.repairMode = JSON.stringify(this.tableDataEdit.repairMode)
        this.commitList.risk = this.tableDataEdit.risk;
        this.commitList.repairMode = this.tableDataEdit.repairMode;
        this.commitList.needAccepter = this.tableDataEdit.needAccepter;
        this.commitList.needAccuracy = this.tableDataEdit.needAccuracy;
        this.commitList.importants = this.tableDataEdit.importants;
        this.commitList.equipmentRepairSolutionList = this.knowledgeListNew;
        this.commitList.equipmentUsePartList = this.$refs.partInfoDisplay.dataList;
        this.commitList.type = '0';
        this.commitList.repairImg = this.mainEditList.repairImg.join(',');
        this.commitList.delayedReason = "";
        if (this.tableDataEdit.reason != null && this.tableDataEdit.reason != '') {
          for (let key in this.tableDataEdit.reason) {
            this.commitList.delayedReason += this.tableDataEdit.reason[key] + ",";
          }
        }
        if (this.tableDataEdit.other1) {
          this.commitList.delayedReason += this.tableDataEdit.otherInput;
        }
        this.commitList.delayed = this.checkList100[0];
        this.commitList.delayedDay = this.tableDataEdit.delayedDay;
        // if(this.checkList100[0]==undefined){
        // 	this.$message({
        // 		message: '请选择维修时限',
        // 		type: 'warning'
        // 	});
        // 	return;
        // }
        if (this.commitList.delayed == '0') {
          this.commitList.delayedReason = "";
        } else {
          if (!this.isNumber(this.tableDataEdit.delayedDay)) {
            // this.$message({
            // 	message: '请填写延时天数(数字)',
            // 	type: 'warning'
            // });
            this.tableDataEdit.risk = JSON.parse(this.tableDataEdit.risk);
            this.tableDataEdit.repairMode = JSON.parse(this.tableDataEdit.repairMode);
            // return;
          }
        }
        Malfunction.saveCommit(this.commitList).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.dialogSpotResult = false;
            this.search({
              pageNum: this.pageNum,
              pageSize: this.pageSize,
            });
            this.$message({
              message: this.$t('label_710'),
              type: 'success'
            });
          }
        }).catch((response) => {
          console.log(response)
        })
      }
    },
    clearSearch(index) {
      if (index == 1) {
        this.$refs.myAutocomplete.handleFocus()
      } else if (index == 2) {
        this.$refs.myAutocomplete2.handleFocus()
      } else if (index == 3) {
        this.$refs.myAutocomplete3.handleFocus()
      } else {
        this.$refs.myAutocomplete4.handleFocus()
      }

    },
    handleSelect(item) {
      this.tableDataEdit.repairman = item.fullName;
      this.tableDataEdit.repairmanId = item.id;
      this.tableDataEdit.repairmanDept = item.repairmanDept;
    },
    handleSelect2(item) {
      this.tableDataEdit.accepter = item.fullName
      this.tableDataEdit.accepterId = item.id
    },
    handleSelect3(item) {
      this.tableDataEdit.participants = item.fullName
      this.tableDataEdit.participantsId = item.id
    },
    handleSelect4(item) {
      this.mainEditList.devicName = item.name;
      this.mainEditList.equipmentId = item.id;
      this.mainEditList.superior = item.superior;
      this.mainEditList.deptId = item.deptId;
      this.mainEditList.typeName = item.typeName;
    },
    handleSelect5(item) {
      this.knowledgeList.typeName = item.name
      this.knowledgeList.equipmentTypeId = item.id
      this.knowledgeListInsert.equipmentTypeId = item.id;
    },
    querySearchAsync3(queryString, cb) {
      let param = {
        name: queryString
      }
      file.selectTypeListByName(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          cb(data.data)
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    querySearchAsync(queryString, cb) {
      file.selectUser(queryString).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          cb(data.data)
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    querySearchAsync1(queryString, cb) {
      file.selectByName(this.mainEditList.devicName).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          cb(data.data)
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    getNow() {
      let zeroTime = new Date();
      let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() +
        1; //月份从0开始，因此要+1
      let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
      let h = zeroTime.getHours() < 10 ? '0' + zeroTime.getHours() : zeroTime.getHours()
      let m = zeroTime.getMinutes() < 10 ? '0' + zeroTime.getMinutes() : zeroTime.getMinutes()
      let s = zeroTime.getSeconds() < 10 ? '0' + zeroTime.getSeconds() : zeroTime.getSeconds()
      let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates + ' ' + h + ':' + m + ':' + s;
      return now;
    },
    // 打开弹出框
    fengxianlihui() {
      if (this.tableDataEdit.risk.length <= 0) {
        // this.valueOpenClose = false;
        utils.messageAlert(this.$t('input_70'), this.$t('label_358'), this.$t('label_100'));
        return;
      }
      this.riskLegislativeCouncil = true
      this.fengxiansearch(1);
    },
    fengxiansearch(status) {
      this.saveStatus = status
      // this.fengxianRiskData = []
      let param = {
        taskId: this.id,
        risk: this.tableDataEdit.risk.toString(),
        status: status
      }
      Malfunction.riskListAll(param).then((response) => {
        const data = response.data;
        if (data.code == '1') {
          this.fengxianriskList = data.data
          for (let i = 0; i < this.fengxianriskList.length; i++) {
            for (let j = 0; j < this.fengxianriskList[i].rkList.length; j++) {
              if (this.fengxianriskList[i].rkList[j].check == 0) {
                this.fengxianRiskData.push(this.fengxianriskList[i].rkList[j])
              }
            }
          }
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    fenxianConfirm(status) {
      this.saveStatus2 = status
      this.dialogLoginF = true;
      this.fengxianConfirmData = {
        taskId: this.id,
        riskIdList: this.fengxianRiskData,
        confirm: status,
        userName: '',
        passWord: '',
        autograph: null,
        repairPlanBeginTime: this.fengxianlihuiTime1,
        repairPlanEndTime: this.fengxianlihuiTime2,
      }
    },
    fengxianLogin() {
      // if (this.saveStatus2 != 5 && this.saveStatus2 != 9) {
      // if (this.saveStatus != this.saveStatus2) {
      // 	utils.messageAlert(this.$t('msg_68'), this.$t('label_717'), this.$t('label_100'));
      // 	return;
      // }
      // }
      Malfunction.confirm(this.fengxianConfirmData).then((response) => {
        const data = response.data;
        if (data.code == '1') {
          this.selectAll();
          this.dialogLoginF = false;
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    xinjian() {
      this.allList = {};
      this.selectValue = '';
      this.selectValue2 = [];
      this.selectValue3 = [];
      this.options = [];
      this.options2 = [];
      this.options3 = [];
      this.dialogSpotResult = true;
      this.mainEditTree = 'project';
      this.fengXianLiHuiTree = '';
      this.mainEditList.reportPerson = this.$store.getters.getCurrentUser.name;
      this.mainEditList.mobile = this.$store.getters.getCurrentUser.mobile;
      this.allList.dispatchTime = this.getNow();
      this.allList.orderNo = '';
      this.mainEditList.fault = '';
      this.mainEditList.faultPhenomenon = [];
      this.mainEditList.devicName = '';
      this.mainEditList.urgentLevel = ''
      this.mainEditList.faultSource = '';
      this.mainEditList.stop = 1;
      this.mainEditList.expectTime = '';
      this.mainEditList.reportTime = this.getNow();
      this.mainEditList.stopTime = '';
      this.mainEditList.faultExplain = '';
      this.mainEditList.faultImg = [];
      this.mainEditList.superior = '';
      this.mainEditList.typeName = '';
      this.receiveList.idea = '';
      this.receiveList.accord = '';
      this.tableDataEdit.id = '';
      this.receiveList.id = '';
      this.commitList.id = '';
      this.receiveList.taskId = '';
      this.tableDataEdit.risk = [];
      this.tableDataEdit.repairMode = [];
      this.tableDataEdit.faultLevel = '';
      this.tableDataEdit.needAccepter = 0;
      this.tableDataEdit.needAccuracy = 0;
      this.tableDataEdit.importants = '';
      this.knowledgeListNew = '';
      this.tableDataEdit.remarks = '';
      this.tableDataEdit.repairman = '';
      this.tableDataEdit.repairmanId = '';
      this.tableDataEdit.accepter = '';
      this.tableDataEdit.accepterId = '';
      this.tableDataEdit.participants = '';
      this.tableDataEdit.participantsId = '';
      this.tableDataEdit.repairmanDept = '';
      this.tableDataEdit.other1 = false;
      this.tableDataEdit.other2 = false;
      this.tableDataEdit.otherInput2 = "";
      this.status = {
        active: 0,
        reportPerson: '',
        reportTime: '',
        dispatcher: '',
        dispatchTime: '',
        receivingPerson: '',
        orderTime: '',
        repairman: '',
        repairBeginTime: '',
        accepter: '',
        acceptBeginTime: '',
        acceptEndTime: '',
      }
      this.lookFlag = 4;
      this.selectDeviceInfo();
    },
    selectDeviceInfo() {
      file.selectByName(this.mainEditList.devicName).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.deviceList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    showdialog(name) {
      this.remoteMethod('');
      this.remoteMethod2('');
      this.remoteMethod3('');
      this.tableDataEdit.other2 = false;
      this.tableDataEdit.otherInput2 = "";
      this.selectDeviceInfo();
      // 刷新厂家和外协列表
      this.getManufacturerList();
      this.getOutsourcingList();
      // 接单标识 1:接单
      let receiveFlag ;
      if (this.tableInfo != undefined) {
        // 派单
        if (name == 'bei') {
          this.showLiHui = true;
          this.lookFlag = 3;
          if (this.tableInfo.status != '1') {
            utils.messageAlert(this.$t('msg_71'), this.$t('label_358'), this.$t('label_100'));
            return;
          }
          // 接单
        } else if (name == 'jie') {
          this.showLiHui = false;
          this.lookFlag = 3;
          if (this.tableInfo.status != '2') {
            utils.messageAlert(this.$t('msg_71'), this.$t('label_358'), this.$t('label_100'));
            return;
          }
          receiveFlag = 1;
          name = 'bei';
          // 维修
        } else if (name == 'feng') {
          this.lookFlag = 2;
          if (this.tableInfo.status != '3' && this.tableInfo.status != '4') {
            utils.messageAlert(this.$t('msg_71'), this.$t('label_358'), this.$t('label_100'));
            return;
          }
          // 验收
        } else if (name == 'receive') {
          this.lookFlag = 1;
          if (this.tableInfo.status != '5' && this.tableInfo.status != '6') {
            utils.messageAlert(this.$t('msg_71'), this.$t('label_358'), this.$t('label_100'));
            return;
          }
        } else if (name == 'project') {
          this.lookFlag = 99;
        } else {
          this.lookFlag = 0;
        }
        if (name == 'bei') {
          this.allList.dispatchTime = this.getNow();
        }
        // if (name == 'project') {
        // this.lookFlag = 99;
        // if (this.tableInfo.status == 8) {
        // 	utils.messageAlert("已关闭,不可查看", this.$t('label_358'), this.$t('label_100'));
        // 	return;
        // }
        // }
        // if (name == 'feng') {
        // 	if (this.tableInfo.status == 3) {
        // 		Malfunction.maintainBegin(this.tableInfo.id).then((response) => {
        // 			const data = response.data;
        // 			if (data.code == "1") {
        // 				this.search({
        // 					pageNum: this.pageNum,
        // 					pageSize: this.pageSize,
        // 				});
        // 			}
        // 		}).catch((response) => {
        // 			console.log(response)
        // 		})
        // 	}
        // }
        if (name == 'project') {
          this.mainEditSheet = 'feng2';
        } else {
          if (this.allList.status == 3 || this.allList.status == 4) {
            if (this.allList.confirm != 99) {
              this.mainEditSheet = 'feng1';
            } else {
              this.mainEditSheet = 'feng2';
            }
          } else {
            this.mainEditSheet = 'feng2';
          }
        }
        this.fengXianLiHuiTree = name;
        this.mainEditTree = name;
        this.mainEditList.faultPhenomenon = this.allList.faultPhenomenon? this.allList.faultPhenomenon.split(","): [];
        this.mainEditList.fault = '';
        this.knowledgeListInsert.fault = '';
        let num = '';
        let ketI = 0;
        for (let key in this.mainEditList.faultPhenomenon) {
          let n = 0;
          for (let i in this.faultPhenomenonList) {
            if (this.mainEditList.faultPhenomenon[key] == this.faultPhenomenonList[i].val) {
              n++;
            }
          }
          if (n == 0) {
            ketI = key;
            num = 1;
          }
        }
        if (num != '') {
          this.mainEditList.fault = this.mainEditList.faultPhenomenon[ketI];
          this.mainEditList.faultPhenomenon[ketI] = this.$t('label_380');
        }
        this.knowledgeListInsert.faultPhenomenon = this.mainEditList.faultPhenomenon[0];
        if (this.knowledgeListInsert.faultPhenomenon == this.$t('label_380')) {
          this.knowledgeListInsert.fault = this.mainEditList.fault;
        }
        this.mainEditList.devicName = this.tableInfo.ename;
        this.mainEditList.reportPerson = this.allList.reportPerson;
        this.mainEditList.deptId = this.allList.deptId;
        this.mainEditList.superior = this.allList.superior;
        this.mainEditList.typeName = this.allList.typeName1;
        this.mainEditList.mobile = this.allList.mobile;
        for (let key in this.urgentList) {
          if (this.urgentList[key].key == this.allList.urgentLevel) {
            this.mainEditList.urgentLevel = this.urgentList[key].val;
          }
        }
        this.mainEditList.faultSource = this.allList.faultSource;
        this.mainEditList.stop = this.allList.stop;
        this.mainEditList.expectTime = this.allList.expectTime;
        this.mainEditList.reportTime = this.allList.reportTime;
        this.mainEditList.stopTime = this.allList.stopTime;
        this.mainEditList.faultExplain = this.allList.faultExplain;
        // this.mainEditList.faultImg = this.allList.faultImg;
        // this.mainEditList.repairImg = this.allList.repairImg;
        if (this.allList.faultImg != null && this.allList.faultImg != '') {
          this.mainEditList.faultImg = this.allList.faultImg.split(',')
        } else {
          this.mainEditList.faultImg = []
        }
        if (this.allList.repairImg != null && this.allList.repairImg != '') {
          this.mainEditList.repairImg = this.allList.repairImg.split(',')
        } else {
          this.mainEditList.repairImg = []
        }
        this.receiveList.idea = this.allList.idea;
        this.receiveList.accord = this.allList.accord;
        this.receiveList.confirm = this.allList.confirm ? this.allList.confirm.toString() : '';
        this.receiveList.distinction = this.allList.distinction ? this.allList.distinction.toString() : '';
        if (this.allList.delayed != null && this.allList.delayed.toString() == "1") {
          this.checkList100.push(this.allList.delayed.toString());
          this.tableDataEdit.other = true;
          this.tableDataEdit.delayedDay = this.allList.delayedDay;
        } else {
          if (this.allList.delayed != null) {
            this.checkList100.push(this.allList.delayed.toString());
          }
          this.tableDataEdit.other = false;
          this.tableDataEdit.delayedDay = "";
          this.tableDataEdit.otherInput = "";
        }
        let reason = [];
        if (this.allList.delayedReason != null && this.allList.delayedReason != "") {
          reason = this.allList.delayedReason.split(',');
        }
        let delayed = [];
        for (let key in this.delayedList) {
          delayed.push(this.delayedList[key].val);
        }
        // let aabb = this.getDifferentData(reason, delayed);
        this.tableDataEdit.other1 = false;
        if (this.delayedList.length > 0 && reason.length > 0 && reason[0] != '') {
          // this.tableDataEdit.other1 = true;
          // this.tableDataEdit.otherInput = aabb[0];
          for (let i = 0; i < reason.length; i++) {
            let num = 0;
            for (let j = 0; j < this.delayedList.length; j++) {
              if (reason[i] == this.delayedList[j].val) {
                num++;
              }
            }
            if (num == 0) {
              this.tableDataEdit.other1 = true;
              this.tableDataEdit.otherInput = reason[i];
              reason.splice(i, 1);
              break;
            }
          }
        }
        this.tableDataEdit.reason = reason;
        let productTrackVal = [];
        let bulkTrackVal = [];
        let productTrackKey = [];
        let bulkTrackKey = [];
        if (this.allList.productTrackVal != null) {
          productTrackVal = this.allList.productTrackVal.split(',');
        }
        if (this.allList.productTrackKey != null) {
          productTrackKey = this.allList.productTrackKey.split(',');
        }
        if (this.allList.bulkTrackVal != null) {
          bulkTrackVal = this.allList.bulkTrackVal.split(',');
        }
        if (this.allList.bulkTrackKey != null) {
          bulkTrackKey = this.allList.bulkTrackKey.split(',');
        }
        this.tableDataEdit.productTrackList = productTrackVal;
        this.tableDataEdit.bulkTrackList = bulkTrackVal;
        for (let key in productTrackKey) {
          if (productTrackKey[key] == '0') {
            this.tableDataEdit.other2 = true;
            this.tableDataEdit.otherInput2 = productTrackVal[productTrackVal.length - 1];
          }
        }
        this.tableDataEdit.id = this.tableInfo.id;
        this.$nextTick(() => {
          this.$refs.partInfoDisplay.selectDataList(this.tableDataEdit.id);
        })
        this.receiveList.id = this.tableInfo.id;
        this.commitList.id = this.tableInfo.id;
        this.receiveList.taskId = this.tableInfo.id;
        if (this.allList.risk != null && this.allList.risk != '') {
          this.tableDataEdit.risk = JSON.parse(this.allList.risk)
        } else {
          this.tableDataEdit.risk = [];
        }
        if (this.allList.repairMode != null && this.allList.repairMode != '') {
          this.tableDataEdit.repairMode = JSON.parse(this.allList.repairMode)
        } else {
          this.tableDataEdit.repairMode = [];
        }
        // this.tableDataEdit.repairMode = this.allList.repairMode;
        this.tableDataEdit.faultLevel = this.allList.faultLevel;
        if (this.allList.needAccepter == null) {
          this.tableDataEdit.needAccepter = 0
        } else {
          this.tableDataEdit.needAccepter = this.allList.needAccepter;
        }
        if (this.allList.needAccuracy == null) {
          this.tableDataEdit.needAccuracy = 0;
        } else {
          this.tableDataEdit.needAccuracy = this.allList.needAccuracy;

        }

        this.tableDataEdit.importants = this.allList.importants;
        this.knowledgeListNew = this.allList.list;
        this.tableDataEdit.remarks = this.allList.remarks;
        if (this.allList.repairman != null) {
          this.options = [{
            id: this.allList.repairmanId,
            fullName: this.allList.repairman
          }];
          this.selectValue = this.allList.repairmanId + "&@" + this.allList.repairman;
        } else {
          this.options = [];
          this.selectValue = '';
        }
        if (this.allList.accepter != null) {
          this.options3 = [{
            id: this.allList.accepterId,
            fullName: this.allList.accepter
          }];
          this.selectValue3 = this.allList.accepterId + "&@" + this.allList.accepter;
        } else {
          this.options3 = [];
          this.selectValue3 = '';
        }
        if (this.allList.participants != "" && this.allList.participants != null && this.allList.participantsId !=
          null) {
          let participantsIdArr = this.allList.participantsId.split(",");
          let participantsArr = this.allList.participants.split(",");
          let selectValue2 = [];
          let options2 = [];
          for (let i = 0; i < participantsArr.length; i++) {
            selectValue2.push(participantsIdArr[i] + "&@" + participantsArr[i]);
            options2.push({
              id: participantsIdArr[i],
              fullName: participantsArr[i]
            })
          }
          this.options2 = options2;
          this.selectValue2 = selectValue2;
        } else {
          this.options2 = [];
          this.selectValue2 = [];
        }
        // this.tableDataEdit.accepter = this.allList.accepter;
        // this.tableDataEdit.accepterId = this.allList.accepterId;
        this.selectknowledge();
        console.log("appointMeet", this.allList.appointMeet)
        if (this.allList.appointMeet == 1) {
          this.getRiskList2(1);
        } else {
          this.getRiskList();
        }
        if (receiveFlag == 1) {
          if (this.allList.repairmanId == this.$store.getters.getCurrentUser.userId || this.allList.participantsId.indexOf(this.$store.getters.getCurrentUser.userId) != -1) {
            this.dialogSpotResult = true;
          } else {
            utils.messageAlert(this.$t('msg_70'), this.$t('label_358'), this.$t('label_100'));
            return false;
          }
        } else {
          this.dialogSpotResult = true;
        }
      } else {
        utils.messageAlert(this.$t('msg_1'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    getDifferentData(arrA, arrB) {
      return arrA.concat(arrB).filter(function(v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v);
      });
    },
    getDictList1() {
      file.getByDictIdALL({dictId: 8, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.faultList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(8).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.faultList = data.data;
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    getDictList2() {
      file.getByDictIdALL({dictId: 12, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.urgentList = data.data;
          this.urgentLevelStatusList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(12).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.urgentList = data.data;
      //     this.urgentLevelStatusList = data.data;
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    getDictList3() {
      file.getByDictIdALL({dictId: 11, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.faultPhenomenonList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(11).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.faultPhenomenonList = data.data;
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    getDictList4() {
      file.getDictList1(9).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.faultReasonClassifyList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    // getDictList5() {
    // 	file.getDictList(10).then((response) => {
    // 		const data = response.data;
    // 		if (data.code == "1") {
    // 			this.faultReasonList = data.data;
    // 		}
    // 	}).catch((response) => {
    // 		console.log(response)
    // 	})
    // },

    getDictList6() {
      file.getByDictIdALL({dictId: 13, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.checkList2 = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(13).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.checkList2 = data.data;
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    getDictList7() {
      file.getByDictIdALL({dictId: 14, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.checkList3 = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(14).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.checkList3 = data.data;
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    getDictList8() {
      file.getByDictIdALL({dictId: 12, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.levelList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList(12).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.levelList = data.data;
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    removeFaultImg(index) {
      this.mainEditList.faultImg.splice(index, 1);
    },
    removeFaultImg2(index) {
      this.mainEditList.repairImg.splice(index, 1);
    },
    upload2(file1) {
      if (this.mainEditList.repairImg.length == 5) {
        utils.messageAlert(this.$t('msg_72'), this.$t('label_358'), this.$t('label_100'));
        return;
      }
      let formData = new FormData();
      formData.append('file', file1.file);
      formData.append('organizationId', this.mainEditList.deptId);
      file.upload(formData).then((response) => {
        const data = response.data;
        let that = this;
        if (data.code == 1) {
          that.showIcon(data.data)
          that.showName(data.data)
          let timer = setTimeout(
            function() {
              that.mainEditList.repairImg.push(data.data)
            },
            500
          );
          // this.mainEditList.repairImg.push(data.data)
          // this.tableDataEdit.fileId = data.data
          this.$message({
            message: this.$t('msg_15'),
            type: 'success'
          });
          this.chooseFile = true;
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    upload(file1) {
      if (this.mainEditList.faultImg.length == 5) {
        utils.messageAlert(this.$t('msg_72'), this.$t('label_358'), this.$t('label_100'));
        return;
      }
      let formData = new FormData();
      formData.append('file', file1.file);
      formData.append('organizationId', this.mainEditList.deptId);
      file.upload(formData).then((response) => {
        const data = response.data;
        let that = this;
        if (data.code == 1) {
          that.showIcon(data.data)
          that.showName(data.data)
          let timer = setTimeout(
            function() {
              that.mainEditList.faultImg.push(data.data)
            },
            500
          );
          // this.mainEditList.faultImg.push(data.data)
          // this.tableDataEdit.fileId = data.data
          this.$message({
            message: this.$t('msg_15'),
            type: 'success'
          });
          this.chooseFile = true;
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    commit() {
      // if (this.mainEditList.faultPhenomenon == this.$t('label_380')) {
      // 	this.mainEditList.faultPhenomenon = this.mainEditList.fault;
      // }
      let num = '';
      if (this.mainEditList.faultPhenomenon != '' && this.mainEditList.faultPhenomenon != null && this.mainEditList.faultPhenomenon !=
        undefined && this.mainEditList.faultPhenomenon.length > 0) {
        if (this.mainEditList.faultPhenomenon.join(",").indexOf(this.$t('label_380')) >= 0) {
          if (this.mainEditList.fault != '' && this.mainEditList.fault != null && this.mainEditList.fault != undefined) {
            this.mainEditList.faultPhenomenon.splice(this.mainEditList.faultPhenomenon.indexOf(this.$t('label_380')), 1)
            this.mainEditList.faultPhenomenon.push(this.mainEditList.fault);
            num = this.mainEditList.faultPhenomenon.length - 1
          } else {
            utils.messageAlert(this.$t('input_81'), this.$t('label_358'), this.$t('label_100'));
            return;
          }
        }
      } else {
        utils.messageAlert(this.$t('input_67'), this.$t('label_358'), this.$t('label_100'));
        return;
      }
      if (this.mainEditList.equipmentId == '' || this.mainEditList.equipmentId == null || this.mainEditList
          .equipmentId ==
        undefined) {
        utils.messageAlert(this.$t('input_34'), this.$t('label_358'), this.$t('label_100'));
        return;
      }
      if (this.mainEditList.urgentLevel == '' || this.mainEditList.urgentLevel == null || this.mainEditList
          .urgentLevel ==
        undefined) {
        utils.messageAlert(this.$t('input_44'), this.$t('label_358'), this.$t('label_100'));
        return;
      }
      if (this.mainEditList.faultSource == '' || this.mainEditList.faultSource == null || this.mainEditList
          .faultSource ==
        undefined) {
        utils.messageAlert(this.$t('input_45'), this.$t('label_358'), this.$t('label_100'));
        return;
      }
      if (this.mainEditList.expectTime == '' || this.mainEditList.expectTime == null || this.mainEditList
          .expectTime ==
        undefined) {
        utils.messageAlert(this.$t('input_82'), this.$t('label_358'), this.$t('label_100'));
        return;
      }
      if (this.mainEditList.stop == '1' && (this.mainEditList.stopTime == '' || this.mainEditList.stopTime == null ||
        this.mainEditList.stopTime ==
        undefined)) {
        utils.messageAlert(this.$t('input_83'), this.$t('label_358'), this.$t('label_100'));
        return;
      }
      if (this.mainEditList.faultImg != null && this.mainEditList.faultImg.length > 0) {
        this.mainEditList.faultImg = this.mainEditList.faultImg.join(',')
      } else {
        this.mainEditList.faultImg = null
      }
      this.mainEditList.faultPhenomenon = this.mainEditList.faultPhenomenon.join(",")
      Malfunction.insert(this.mainEditList).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.dialogSpotResult = false;
          this.search({
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          });
        } else {
          utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
          this.mainEditList.faultPhenomenon = this.mainEditList.faultPhenomenon.split(',');
          if (num != '') {
            this.mainEditList.faultPhenomenon[num] = this.$t('label_380');
          }
          if (this.mainEditList.faultImg != null && this.mainEditList.faultImg != '') {
            this.mainEditList.faultImg = this.mainEditList.faultImg.split(',');
          }
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    selectAll() {
      Malfunction.selectById(this.id).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.allList = data.data;
          if (!this.riskLegislativeCouncil) {
            if (this.allList.appointMeet == 1) {
              this.valueOpenClose = true;
            } else {
              this.valueOpenClose = false;
            }
          }
          // 确认字段名是否正确
                // 调试：查看后端返回的数据结构
      console.log('后端返回的 allList:', this.allList);
      console.log('manufacturerName:', this.allList.manufacturerName);
      console.log('outsourcingName:', this.allList.outsourcingName);
          this.tableDataEdit.manufacturer = this.allList.manufacturerName;
          this.tableDataEdit.outsourcing = this.allList.outsourcingName;
          // this.fengxianlihuiTime = [];
          this.fengxianlihuiTime1 = this.allList.repairPlanBeginTime
          this.fengxianlihuiTime2 = this.allList.repairPlanEndTime
          this.receiveList.confirm = this.allList.confirm
          let info = data.data;
          //处理状态 1：待派单；2：待确认；3：待维修；4：维修中；5：待验收；6：验收中；7：已完成；8：已关闭
          let active = Number(info.status);
          if (active >= 5) {
            active--;
          }
          this.status = {
            active: active,
            reportPerson: info.reportPerson,
            reportTime: info.reportTime == undefined ? '' : info.reportTime.slice(0, 16),
            dispatcher: info.dispatcher,
            dispatchTime: info.dispatchTime == undefined ? '' : info.dispatchTime.slice(0, 16),
            receivingPerson: info.receivingPerson,
            orderTime: info.orderTime == undefined ? '' : info.orderTime.slice(0, 16),
            repairman: info.repairman,
            repairBeginTime: info.repairBeginTime == undefined ? '' : info.repairBeginTime
              .slice(0, 16),
            accepter: info.accepter,
            acceptBeginTime: info.acceptBeginTime == undefined ? '' : info.acceptBeginTime
              .slice(0, 16),
            acceptEndTime: info.acceptEndTime == undefined ? '' : info.acceptEndTime.slice(0,
              16),
          }
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    selectknowledge3(index) {
      if (this.knowledgeSelect2.faultReasonClassify == '') {
        this.knowledgeSelect2.faultReason = ''
      } else {
        file.getDictList2({name: this.knowledgeSelect2.faultReasonClassify, languageType: sessionStorage.getItem("languageType")}).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.causeList = data.data;
            if (index == 0) {
              this.knowledgeSelect2.faultReason = '';
            }
          }
        }).catch((response) => {
          console.log(response)
        })
        // file.getDictList2(this.knowledgeSelect2.faultReasonClassify).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.causeList = data.data;
        //     if (index == 0) {
        //       this.knowledgeSelect2.faultReason = '';
        //     }
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
      }
      this.knowledgeSelect2.id = this.mainEditList.equipmentId
      Malfunction.knowledge2(this.knowledgeSelect2).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.knowledgeList2 = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    selectknowledge() {
      let param = {name: this.knowledgeSelect.faultReasonClassify, languageType: sessionStorage.getItem("languageType")};
      console.log("param", param)
      file.getDictList2({name: this.knowledgeSelect.faultReasonClassify, languageType: sessionStorage.getItem("languageType")}).then((response) => {//, languageType: sessionStorage.getItem("languageType")
        const data = response.data;
        if (data.code == "1") {
          this.causeList = data.data;
          this.knowledgeSelect.faultReason = this.causeList[0].val;
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList2(this.knowledgeSelect.faultReasonClassify).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.causeList = data.data;
      //     this.knowledgeSelect.faultReason = this.causeList[0].val;
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
      Malfunction.knowledge(this.knowledgeSelect).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.knowledgeList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    selectknowledge2() {
      file.getDictList2({name: this.knowledgeSelect.faultReasonClassify, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.causeList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList2(this.knowledgeSelect.faultReasonClassify).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.causeList = data.data;
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
      Malfunction.knowledge(this.knowledgeSelect).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.knowledgeList = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    solution() {
      let param = {
        id: this.tableDataEdit.id,
        list: this.knowledgeListNew
      }
      Malfunction.solution(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.dialogSpotResult = false;
          this.selectAll();
          this.$message({
            message: this.$t('label_707'),
            type: 'success'
          });
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    rapidProcessing() {
      let param = {
        id: this.tableDataEdit.id,
        repairImg: this.mainEditList.repairImg.join(','),
        list: this.knowledgeListNew
      }
      Malfunction.rapidProcessing(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.dialogSpotResult = false;
          this.selectAll();
          this.$message({
            message: this.$t('label_707'),
            type: 'success'
          });
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    receive(param) {
      if (this.allList.confirm == 0) {
        if (param != 1) {
          this.$message({
            message: this.$t('input_84'),
            type: 'warning'
          });
          return;
        }
      }
      if (this.allList.confirm == 1) {
        if (param != 2) {
          this.$message({
            message: this.$t('input_85'),
            type: 'warning'
          });
          return;
        }
      }
      if (this.allList.confirm == 2) {
        if (param != 3) {
          this.$message({
            message: this.$t('input_1'),
            type: 'warning'
          });
          return;
        }
      }
      if (this.allList.confirm == 3) {
        if (param != 4) {
          this.$message({
            message: this.$t('input_2'),
            type: 'warning'
          });
          return;
        }
      }
      if (this.allList.appointMeet == 1) {
        if (this.allList.confirm == 4) {
          if (param != 5) {
            this.$message({
              message: this.$t('input_3'),
              type: 'warning'
            });
            return;
          }
        }
        if (this.allList.confirm == 5) {
          if (param != 9) {
            this.$message({
              message: this.$t('input_4'),
              type: 'warning'
            });
            return;
          }
        }
      } else {
        if (this.allList.confirm == 4) {
          if (param != 5) {
            this.$message({
              message: this.$t('input_4'),
              type: 'warning'
            });
            return;
          }
        }
      }
      this.saveStatus2 = param
      this.receiveList.confirm = param;
      this.receiveList.userName = '';
      this.receiveList.passWord = '';
      this.dialogLogin = true;
      if (this.allList.appointMeet == 1) {
        this.dialogLogin = true;
      } else {
        if (param == '1') {
          if (this.allList.autograph1 == null) {
            this.dialogLogin = true;
          } else if (this.allList.distinction != null && this.allList.distinction == '2') {
            this.dialogLogin = true;
          } else if (this.allList.autograph1 != null && this.allList.autograph1.length > 50) {
            this.imgUrl = this.allList.autograph1;
            this.dialogImg = true;
          }
        } else if (param == '2') {
          if (this.allList.autograph2 == null) {
            this.dialogLogin = true;
          } else if (this.allList.distinction != null && this.allList.distinction == '2') {
            this.dialogLogin = true;
          } else if (this.allList.autograph2 != null && this.allList.autograph2.length > 50) {
            this.imgUrl = this.allList.autograph2;
            this.dialogImg = true;
          }
        } else if (param == '3') {
          if (this.allList.autograph3 == null) {
            this.dialogLogin = true;
          } else if (this.allList.distinction != null && this.allList.distinction == '2') {
            this.dialogLogin = true;
          } else if (this.allList.autograph3 != null && this.allList.autograph3.length > 50) {
            this.imgUrl = this.allList.autograph3;
            this.dialogImg = true;
          }
        } else if (param == '4') {
          if (this.allList.autograph4 == null) {
            this.dialogLogin = true;
          } else if (this.allList.distinction != null && this.allList.distinction == '2') {
            this.dialogLogin = true;
          } else if (this.allList.autograph4 != null && this.allList.autograph4.length > 50) {
            this.imgUrl = this.allList.autograph4;
            this.dialogImg = true;
          }
        } else if (param == '5') {
          if (this.allList.autograph5 == null) {
            this.dialogLogin = true;
          } else if (this.allList.distinction != null && this.allList.distinction == '2') {
            this.dialogLogin = true;
          } else if (this.allList.autograph5 != null && this.allList.autograph5.length > 50) {
            this.imgUrl = this.allList.autograph5;
            this.dialogImg = true;
          }
        } else if (param == '9') {
          if (this.allList.autograph6 == null) {
            this.dialogLogin = true;
          } else if (this.allList.distinction != null && this.allList.distinction == '2') {
            this.dialogLogin = true;
          } else if (this.allList.autograph9 != null && this.allList.autograph9.length > 50) {
            this.imgUrl = this.allList.autograph9;
            this.dialogImg = true;
          }
        }
      }
    },
    receive1(param) {
      if (this.lookFlag != 99) {
        this.receiveList.confirm = param;
        this.receiveList.userName = '';
        this.receiveList.passWord = '';
        this.receiveList.idea = '';
        this.receiveList.accord = '';
        if (param == '6') {
          if (this.allList.autograph6 == null) {
            this.dialogLogin1 = true;
          } else if (this.allList.autograph6 != null && this.allList.autograph6.length > 50) {
            this.imgUrl = this.allList.autograph6;
            this.dialogImg = true;
          }
        } else if (param == '7') {
          if (this.allList.autograph7 == null) {
            this.dialogLogin1 = true;
          } else if (this.allList.autograph7 != null && this.allList.autograph7.length > 50) {
            this.imgUrl = this.allList.autograph7;
            this.dialogImg = true;
          }
        } else if (param == '8') {
          if (this.allList.autograph8 == null) {
            this.dialogLogin1 = true;
          } else if (this.allList.autograph8 != null && this.allList.autograph8.length > 50) {
            this.imgUrl = this.allList.autograph8;
            this.dialogImg = true;
          }
        }
      }

    },
    save1() {
      this.saveLoading = true;
      this.commitList.productTrackKey = '';
      this.commitList.productTrackVal = '';
      this.commitList.bulkTrackKey = '';
      this.commitList.bulkTrackVal = '';
      this.commitList.importants = this.tableDataEdit.importants;
      for (let key in this.tableDataEdit.productTrackList) {
        for (let k in this.productTrackList) {
          if (this.tableDataEdit.productTrackList[key] == this.productTrackList[k].val) {
            this.commitList.productTrackKey += this.productTrackList[k].key + ",";
            this.commitList.productTrackVal += this.productTrackList[k].val + ",";
          }
        }
      }
      if (this.tableDataEdit.other2) {
        this.commitList.productTrackKey += "0";
        this.commitList.productTrackVal += this.tableDataEdit.otherInput2;
      }
      for (let key in this.tableDataEdit.bulkTrackList) {
        for (let k in this.bulkTrackList) {
          if (this.tableDataEdit.bulkTrackList[key] == this.bulkTrackList[k].val) {
            this.commitList.bulkTrackKey += this.bulkTrackList[k].key + ",";
            this.commitList.bulkTrackVal += this.bulkTrackList[k].val + ",";
          }
        }
      }
      this.commitList.bulkTrackKey = this.commitList.bulkTrackKey.substring(0, this.commitList.bulkTrackKey.length -
        1);
      this.commitList.bulkTrackVal = this.commitList.bulkTrackVal.substring(0, this.commitList.bulkTrackVal.length -
        1);
      let param = {
        id: this.commitList.id,
        productTrackKey: this.commitList.productTrackKey,
        productTrackVal: this.commitList.productTrackVal,
        bulkTrackKey: this.commitList.bulkTrackKey,
        bulkTrackVal: this.commitList.bulkTrackVal,
        importants: this.tableDataEdit.importants
      }
      Malfunction.importSet(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.$message({
            message: this.$t('msg_21'),
            type: 'success'
          });
        }
        this.saveLoading = false;
      }).catch((response) => {
        console.log(response)
        this.saveLoading = false;
      })
    },
    quick() {
      this.quickData = '1';
      this.selectknowledge();
    },
    closeTask() {
      if (this.tableInfo != undefined) {
        if (this.tableInfo.status == '7') {
          utils.messageAlert(this.$t('msg_8'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        this.$confirm(this.$t('msg_12'), this.$t('label_358'), {
          confirmButtonText: this.$t('label_100'),
          cancelButtonText: this.$t('btn_1'),
          type: 'warning'
        }).then(() => {
          Malfunction.close(this.tableInfo.id).then((response) => {
            const data = response.data;
            if (data.code == "1") {
              this.$message({
                message: this.$t('msg_13'),
                type: 'success'
              });
              this.search({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
              });
            }
          }).catch((response) => {
            console.log(response)
          })
        }).catch(() => {

        });
      } else {
        utils.messageAlert(this.$t('msg_1'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    back() {
      if (this.tableInfo != undefined) {
        if (this.tableInfo.status == '5' || this.tableInfo.status == '6' || this.tableInfo.status == '7' || this
          .tableInfo.status == '8') {
          utils.messageAlert(this.$t('msg_27'), this.$t('label_358'), this.$t('label_100'));
          return;
        }
        this.$confirm(this.$t('msg_28'), this.$t('label_358'), {
          confirmButtonText: this.$t('label_100'),
          cancelButtonText: this.$t('btn_1'),
          type: 'warning'
        }).then(() => {
          this.causedialog = true;
          this.dialogCause = '';
        }).catch(() => {

        });
      } else {
        utils.messageAlert(this.$t('msg_1'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    causedialogClose() {
      this.causedialog = false;
    },
    backcause() {
      if (this.dialogCause == '' || this.dialogCause == null) {
        utils.messageAlert(this.$t('input_5'), this.$t('label_358'), this.$t('label_100'));
        return;
      }
      Malfunction.back2(this.tableInfo.id, this.dialogCause).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.$message({
            message: this.$t('退回成功'),
            type: 'success'
          });
          this.causedialog = false;
          this.search({
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          });
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    insert() {
      // this.knowledgeListInsert.faultPhenomenon = '';
      // this.knowledgeListInsert.fault = '';
      // this.knowledgeListInsert.faultExplain = '';
      this.knowledgeListInsert.faultExplain = this.mainEditList.faultExplain;
      this.knowledgeListInsert.faultReasonClassify = '';
      this.knowledgeListInsert.faultReason = '';
      this.knowledgeListInsert.checkList3 = [];
      this.knowledgeListInsert.checkList1 = [];
      this.knowledgeListInsert.other = '';
      this.knowledgeListInsert.otherInput = '';
      this.knowledgeListInsert.solution = '';
      this.knowledgeListInsert.checkList2 = [];
      this.knowledgeListInsert.impactKey = '';
      this.knowledgeListInsert.impactVal = '';
      this.knowledgeListInsert.precautionKey = '';
      this.knowledgeListInsert.precautionVal = '';
      this.knowledgeListInsert.precaution = '';
      // this.knowledgeListInsert.typeName = '';
      this.knowledgeListInsert.typeName = this.allList.typeName1;
      this.knowledgeListInsert.equipmentTypeId = this.allList.typeId1;
      this.unInsertVisible = true;
    },
    getNameList2(param) {
      this.faultReasonList = [];
      this.knowledgeListInsert.faultReason = "";
      file.getDictList2({name: param, languageType: sessionStorage.getItem("languageType")}).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.faultReasonList = data.data;
          this.knowledgeListInsert.faultReason = this.faultReasonList[0].val;
        }
      }).catch((response) => {
        console.log(response)
      })
      // file.getDictList2(param).then((response) => {
      //   const data = response.data;
      //   if (data.code == "1") {
      //     this.faultReasonList = data.data;
      //     this.knowledgeListInsert.faultReason = this.faultReasonList[0].val;
      //   }
      // }).catch((response) => {
      //   console.log(response)
      // })
    },
    levelSelect() {
      this.selectDataList.urgentLevel1 = this.selectDataList.urgentLevel1.slice(-1);
    },
    deviceChoose(item) {
      let arr = item.split("&@");
      this.mainEditList.devicName = arr[1];
      this.mainEditList.equipmentId = arr[0];
      this.mainEditList.superior = arr[2];
      this.mainEditList.deptId = arr[3];
      this.mainEditList.typeName = arr[4];
    },
    isNumber(val) {
      let regPos = /^[0-9]+.?[0-9]*/; //判断是否是数字。
      if (regPos.test(val)) {
        return true;
      } else {
        return false;
      }
    },
    showBtn() {
      this.qrCodeShow = !this.qrCodeShow;
      if (this.qrCodeShow) {
        this.width = "0px";
      } else {
        this.width = "340px";
      }
    },
    repairTaskExportExcel() {
      this.selectDataList.urgentLevel = this.selectDataList.urgentLevel1;
      for (let i = 0; i < this.spotStatusNumList.length; i++) {
        if (this.spotStatusNumList[i].check) {
          this.selectDataList.status.push(this.spotStatusNumList[i].type);
        }
      }
      this.selectDataList.beginTime = this.Readytime[0] + " 00:00:00";
      this.selectDataList.endTime = this.Readytime[1] + " 23:59:59";
      let dataParam = this.selectDataList;
      Malfunction.repairTaskExportExcel(dataParam).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        let link = document.createElement('a')
        link.href = url
        link.download = decodeURIComponent(response.headers['content-disposition'].split('fileName=')[1])
        link.click()
        URL.revokeObjectURL(url)
      })
    }
  },
  created() {
    this.Readytime = [this.getThreeDaysAgo(), this.getNowTime()]
    this.MenuRoleList = this.$store.getters.getMenu;
    this.selectdictList();
    this.getDictList1();
    this.getDictList2();
    this.getDictList3();
    this.getDictList4();
    // this.getDictList5();
    this.getDictList6();
    this.getDictList7();
    this.getDictList8();
    this.getManufacturerList();
    this.getOutsourcingList();
  }
}
</script>
<style scoped>
.chooseBox6 {
  width: 100%;
}

.fengxianlihuiz1 {
  height: 94%;
  margin-top: 10px;
}
</style>
<style>
.knowpop {
  height: 550px !important;
}

.fengxianz1 {
  font-size: 16px;
  margin-top: 8px;
  width: 55%;
  float: left;
  font-weight: bold;
}

.fengxianz2 {
  font-size: 16px;
  margin-top: 8px;
  width: 16%;
  float: left;
  font-weight: bold;
}

.fengxianz3 {
  font-size: 16px;
  margin-top: 8px;
  width: 13%;
  float: left;
  font-weight: bold;
}

.fengxianlihuiz {
  float: left;
}

.spotStatusNumListSmall.spotStatusNumList .statusMesBox {
  width: 10%;
}

.knowledge {
  width: calc(50% - 25px);
  float: left;
  height: 230px;
  overflow-y: auto;
  font-size: 16px;
  font-weight: 600;
}

.knowledgeChild {
  border: 1px solid #CCCCCC;
  width: calc(100% - 30px);
  float: left;
  margin-top: 5px;
  font-size: 16px;
  font-weight: 600;
  margin-left: 5px;
}

.knowledgeChild2 {
  width: 20px;
  float: left;
}

.knowledgeChild span {
  margin: 10px;
  width: calc(100% - 220px);
  display: inline-block;
}

.knowledge .el-checkbox__label {
  width: calc(100% - 30px);
}

.knowledge .el-checkbox {
  width: 100%;
  margin-right: 0px;
}

.knowledge .el-checkbox,
.el-checkbox__input {
  white-space: initial;
}

.knowledge .el-input__inner {
  height: 35px;
  line-height: 35px;
}

.knowledge .el-input__icon {
  line-height: 35px;
}

.knowledge .el-select {
  width: 45%;
}

.aaa .el-steps--simple {
  background: #efefef;
}

.bbb .el-dialog {
  /* height: 880px; */
  margin: 0px auto 30px;
}

.bbb .el-dialog__body {
  padding: 10px 20px;
  height: calc(100% - 54px);
}

.bbb .el-tabs--left .el-tabs__header.is-left {
  width: 160px;
  margin-right: 30px;
}

.bbb .el-tabs--left .el-tabs__item.is-left {
  text-align: right;
}

.bbb .el-tabs .el-tabs__content {
  overflow-y: auto;
  height: 94%;
}

.aaa .el-tabs__content {
  /* height: 400px; */
}

.repairClass {
  height: 100%;
}

.repairClass .el-tabs__content {
  height: 100%;
}

.fengxian .el-dialog__body {
  height: calc(100% - 55px);
}

.fengxian .el-dialog {
  height: 85%;
  /* margin: 0 auto 43px;; */
}

.fengxian .el-tabs--border-card {
  height: 100%;
}

.fengxianfenxi .el-tabs__item {
  width: 100%;
}

.riskLiskBox {
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
}

.ridk {
  width: 50%;
  margin-bottom: 10px;
}

.abc .el-input__inner {
  height: 31px;
}

.querendiv {
  border-bottom: 1px solid #CCCCCC;
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 50px;
}

.querendiv2 {
  width: 100%;
  height: 80px;
  text-align: center;
  line-height: 80px;
}

.querendiv3 {
  border: 1px solid #CCCCCC;
  width: 100%;
  height: 130px;
}

.querendiv4 {
  background-color: #9acefe;
  font-weight: 900;
  font-size: 16px;
}
.right-showbtn-qrcode-background {
  /* position: absolute; */
  width: 10px;
  height: 80px;
  background-color: #9c9c9c;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  margin: auto;
}
.right-showbtn {
  width: 10px;
  height: 100%;
  display: flex;
  position: relative;
  z-index: 100000;
}
</style>



// WEBPACK FOOTER //
// src/pages/malfunction/malfunctionRepairPage.vue